/**
 * Created by zhujunjie on 2017/12/29.
 */

const message = {
  //公共
  common: {
    del_confirm_title:'Delete Confirmation',
    del_config_tips1:'You will delete all selected configurations, please confirm',
    del_config_tips2:'You will delete all selected configurations, and devices will also clear these configurations, please confirm',
  },
  yd: {
    menu : {
      my_device: 'Device Brief',
      data_center: 'Data Center',
      remote_clear_lockpass : 'Restore Default Setting',
      device_restore : 'Device Restore',
      address_manage : 'Location Management',
      restore_date_record: 'Restore factory records',
      remote_app_manage: 'Application Management',
      remote_usage_record : 'Remote Log',
      remote_manage_menu : 'Remote Management',
      remote_configuration:'Configuration Deployment',
      devicedistributionmanage : 'Device Ownership',
      sysCustomization: 'System Customization',
      devicedistribution : 'Distribute Device',
      devicedonate : 'Device Transfer',
      devicedonaterecord : 'Transfer Record',
      occupyScreen: 'Kiosk Mode',
      silentApp: 'Auto-start Application',
      customDesk: 'Customized Desktop',
      index : 'Location',
      dashboard : 'Partner Connect',
      usermanage : 'User Management',
      userinfo : 'User Information',
      userlist : 'User List',
      useredit : 'Edit a User',
      useradd : 'Add a User',
      changepass : 'Change Password',
      organization : 'Organization Management',
      organizationlist : 'Organization List',
      organizationadd : 'Add an Organization',
      organizationdetail : 'Organization Details',
      app : 'Application Management',
      applist : 'App List',
      authorityManagement : 'Authority Management',
      apppublish : 'App Publish',
      appshelf : 'Apps on the Shelf',
      onshelf: 'Apps Available on the Shelf',
      notonshelf: 'Apps not on the Shelf',
      appadd : 'Add an App',
      appupdate : 'Update the App',
      device : 'Terminal Management',
      device_management : 'Management',
      devicemonitor : 'Device information monitoring',
      fence : 'Electronic fence',
      drawfence : 'Draw fence',
      deviceexport : 'Import devices in batches',
      deviceadd : 'Add a device',
      deviceedit : 'Edit the device',
      functionforbidden : 'Function disabled',
      configuration : 'Configuration management',
      appcenter : 'Application center configuration',
      thirdapp : 'Third-party application configuration',
      notfound : 'Page not found',
      errorpage : 'Error page',
      home : 'Dashboard',
      dataCenter: 'Data Center',
      deviceMap: 'Device Map',
      account_manage : 'Account Center',
      company_info : 'Company Information',
      personal_info : 'Personal Information',
      my_operator : 'Authorization Control',
      children_account : 'Sub-account',
      my_children_account : 'Sub-account Brief',
      app_market: 'App Management',
      menu_banner: 'Banner',
      menu_app_upload : 'App Submit',
      menu_inside_app:'UTMS App',
      menu_app_check : 'App Review',
      app_manage : 'Application Management',
      app_detail : 'App Details',
      app_add : 'App Details',
      app_param_config:'Param Settings',
      app_deploy:'Silent Installation',
      app_version_manage : 'Version Management',
      app_manage_content : 'Management Content',
      device_app_info: 'Application Brief',
      device_life_cycle: 'Device Lifecycle',
      remote_assistance: 'Remote Assistance',
      device_config: 'Device Configuration',
      my_boot_animation: 'My Boot Animation',
      group_manager:'Group Management',
      remote_screen:'Remote Desktop',
      after_sale_service:'After Sale Center',
      apply_after_sale:'Apply',
      service_progress:'Progress',
      flow_manage:'Flow Management',
      visitInfoStatistic:'Visit Info Statistic',
      abnormalAlarmStatistics:'Abnormal Alarm Statistics',
      organization_management: 'Merchant',
      manufacturer_management:'Model Management',
      manufacturer_dvc_type:'Device Type',
      device_detail:'Terminal Details',
      device_detail_tab:'Terminal Details Tab',
      organization_management_another: 'Group Management',
      organization_management_repository: 'Binding Terminal',
      basesetting: 'Base Setting',
      operation_log: 'Operation Log',
      authority_management: 'Authority Management',
      platform_settings:'Settings',
      ota: 'OTA',
      device_task:'Terminal Task',
      param_add:'Add application parameters',
      param_edit:'App parameter clone',
      param_edit1:'App parameter edit',
      param_view:'View application parameters',
      occupy_screen:'Occupy Screen',
      log_manage:"Log Manage",
    },
    index : {
      pic1_desc1:'Remote Management',
      pic1_desc2:'Wearable Mobile Computer U2',
      pic1_desc3:'Enterprise Mobile Computer i6310',
      pic1_desc4:'Enterprise Mobile Computer i6200S',
      pic2_desc1:'MOBILE PAYMENT TERMINALS',
      pic2_desc2:'Desktop QR Code Scanner Q500',
      pic2_desc3:'Handheld Payment Terminal i9100',
      pic2_desc4:'Handheld Payment Terminal i9100S',
      pic3_desc1:'HANDHELD RFID READERS',
      pic3_desc2:'Ruggedized UHF RFID Mobile Computer V5100',
      pic3_desc3:'',
      pic3_desc4:'',
      pic4_desc1:'PORTABLE SCANNERS & MOBILE PRINTERS',
      pic4_desc2:'Portable Scanner S770',
      pic4_desc3:'Thermal Barcode Printer D7000',
      pic4_desc4:'Wireless Portable Scanner S810',
      pic5_desc1:'AUTOMATION 3D WAREHOUSE',
      pic5_desc2:'Intelligent WMS',
      pic5_desc3:'Intelligent Multi-wear System',
      pic5_desc4:'Intelligent Stacker Stereo Library',
    },
    function : {
      personal : 'Personal information',
      changeavatar : 'Change avatar',
      changepass : 'Change password',
      logout : 'Logout',
      changePic:'Change Picture',
      changePwd:'Change Password',
      version:'Version',
      return_manage: 'Return to the parent account',
      changelanguage: 'Change Language'
    },
    customer:{
      select_return_address_tip:'Please select the repair point to submit',
      max_select_error: 'Select up to three items',
      select_row_delete: 'Please select delete row to delete',
      company_info_mix: 'Company information is not complete',
      return_repair_info_mix: 'The repair information is not filled in completely',
      no_sn: 'The device serial number is not filled in',
      select_q: 'Please select the fault problem',
      no_fuhao: 'There cannot be a comma at the end of the device serial number',
      no_space: 'There must be no space at the end of the device serial number',
      no_end_space: 'There must be no spaces in the device serial number',
      no_end_sn: 'No sn at the end',
      sn_1_30: 'The device serial number is 1-30 digits or letters',
      douhao_fenge: 'The device serial number is separated by comma',
      step1: 'Company Info',
      step2: 'Rpair Info',
      step3: 'Choose Station',
      step4: 'Done',
      company_info: 'Company Info',
      company_name: 'Company Name:',
      contact_person: 'Contact:',
      contact_email: 'Contact Email:',
      contact_tel: 'Contact Phone:',
      return_address: 'Return Address',
      select_area: 'Select Area:',
      address: 'Detailed Address:',
      next_step: 'Next',
      last_step: 'Previous Step',
      company_name_tip: 'Please enter the company name',
      contact_person_tip: 'Please enter a contact',
      contact_tel_tip: 'Please enter the contact number',
      contact_email_tip: 'Please enter the contact email',
      address_tip: 'Please enter detailed address',
      express_tip1:'Please enter the name of the express company',
      express_tip2:'Please enter the express number',
      select_malfunction_type: 'Select fault problem',
      submit0: 'Submit',
      select_area_tip: 'Please select provinces and cities',
      step2_top_tip: 'Tip: The repaired equipment removes the random accessories: battery, SIM card, memory card (remove the battery back cover if there is no wrist strap). ',
      enter_back_info: 'Fill in repair information',
      no: 'serial number',
      device_sn: 'Device serial number / SN',
      every_list_sn_enter_tip: 'Please enter the SN of the equipment to be repaired, separated by English commas between different equipment; for example: 12345,12346',
      malfunction_type: 'Fault problem',
      select_malfunction_type_tip: 'Please select the fault problem',
      remark: 'Remarks',
      enter_remark_tip: 'Please enter remarks (optional)',
      step3_tip: 'Tip: the address for repairing, the principle of proximity, so as not to delay your use. ',
      select_return_address: 'Select the repair point',
      accept: '(Receiving)',
      submit_success: 'Submit Successful',
      enter_express_no_quckly: 'Please fill in the express number as soon as possible',
      other_tip0: 'You can add the courier note number or query the acceptance site information, etc. at the after-sales progress inquiry place',
      accept_address: 'Acceptance Site',
      enter_express: 'Enter Express',
      scan_service_progress: 'Check Progress',
      express_name: 'Express Company',
      express_no: 'Express Number',
      please_enter_no: 'Enter Express',
      email_validate_tip: 'Please enter the contact email',
      tel_validate_tip: 'Please enter the contact number',
      progress_search_tip: 'SN number / Express Number',
      query0: 'Search',
      device_sn_0: 'Devices',
      apply_time: 'Applly Date',
      weixiu_address: 'Repair station',
      detail0: 'Details',
      dvc_type: 'Device type',
      return_date: 'Return date',
      return_express_no: 'Return number',
      receiver: 'Recipient',
      repair_status: 'Repair status',
      enter_sn_tip: 'Please enter the SN number',
      select_express_no: 'Select return single number',
      select_status: 'Select status',
      after_sale_detail: 'After sale details',
      text0: 'The device is still on the road, the site is to be signed',
      text1: 'Equipment needs maintenance cost, the quotation will be sent to your mailbox in the near future, please check it',
      text2: 'The device has been repaired and will be sent immediately',
      text3: 'You have confirmed not to repair, please call 0755-22673993 to request the original return',
      text4: 'The equipment has been received and is being repaired',
      text5: 'The device has been returned, please check',
      text6: 'The equipment has been sent, please check',
      text7: 'You have agreed to the quotation, if you have not paid, please arrange payment as soon as possible',
      text8: 'The equipment needs a quotation, please check your email. If you do not receive the quotation, please contact 0755-86520009',
      text9: 'Your device has been paid',
    },
    //配置操作记录
    rule:{
      rule_name:'Name',
      rule_version:'Version',
      operate_user:'Operate User',
      version:'version',
      push_circle:'Push Range',
      operate_time:'Operate Time',
      operate:'Operation',
      view_push_content:'View Content',
      pushRange:'View PushRange',
      operate_record:'Operate Record',
      record_return:'Back',
      record_content:'record content',
      record_modal_close:'close',
      app_deploy:'App Deploy',
      unfinish_sn:'Unfinished SN',
      unfinish_title:'Finish Status',
      sn:'SN',
      dvc_org:'Owner',
      schedule:'Schedule',
      sn_own_group:'Own Group',
      has_push_group:'pushed',
      has_push_status:'Pushed',
      will_push_status:'Unpushed',


    },
    //设备相关
    device:{
      sn:'SN',
      dvc_type:'device model',
      tid:'TID',
      status:'Status',
      property_agency:'Property agency',
      device_task:'Device task',
      device_task_log_0:'Terminal task log',
      list_detail:'Details',
      operation:'Operation',
      scan:'View',
      scan_details:'View details',
      to_order:'Instructional operation',
      manufacturer_name:'Manufacturer',
      query_dvc_type:'Model',
      mid:'MID',
      utms_sn:'SN',
      query_condition:'Filter',
      device_list_count:'in total',
      tai:'',
      last_address:'Location',
      export_btn:'Export',
      export_file_name:'DeviceList',
      query:'Search',
      reset:'Reset',
      device_tab_device_detail:'Device Details',
      device_tab_latest_upload_time:'Latest upload time：',
      device_tab_power:'Power',
      device_tab_power_consumption:'Power Consumption',
      device_tab_device_apps:'Device Applications',
      device_hardware_detection:'HW Detection',
      detection_time:'detection date',
      detection_result:'Detection result',
      detection_exception:'Exception item',
      exception_item:'Exception',
      skip_item:'skip',
      icc_exception:'ICC',
      mag_exception:'MAG',
      picc_exception:'PICC',
      printer_exception:'Printer',
      scanner_exception:'Scan head',
      frontCamera_exception:'Front Camera',
      rearCamera_exception:'Rear camera',
      detection_ok:'Health',
      detection_no:'Abnormal',
      detection_normal:'Normal',

      hardware_detection:'Hardware Detection',
      test_results:'Test Results',
      test_results_details:'Test Result Details',
      test_results_1:'Total detection',
      test_results_item:' item',
      test_results_2:'by ',
      test_results_3:'jump over ',
      test_results_4:'abnormal ',

      device_no:'SN',
      device_type:'Device Type',
      pre_card:'Pre-installed card',
      sim_card_no:'SIM card number',
      sim_serious_no:'SIM serial number',
      current_sim_master:'Current Master Card',
      current_sim_secondary:'Current secondary card',
      flash_id:'Flash ID',
      ip:'IP',
      option:'Option',
      download_log_file:'Download',
      sim_operator:'operator',
      android_version:'Android version',
      ram_dosage:'RAM Usage',
      rom_dosage:'ROM Total',
      data_flow:'Data Flow',
      data_wifi_flow:'WIFI Flow',
      data_sim1_flow:'SIM1 Flow',
      data_sim2_flow:'SIM2 Flow',
      used:'Used',
      remain:'Remaining',
      app_name:'Application Name',
      app_version_name:'Version Name',
      app_version_code:'Version Number',
      app_package:'Package Name',
      app_size:'Size',
      system_app:'System Application',
      third_app:'Third Party Application',



      //Instruction related
      order_device_operate:'Device operation',
      order_operate_los:'Operation log',
      operate_content:'Operation content',
      operate_time:'Operation time',
      operator:'Operator',
      browser:'Browser',
      disable:'Disable',
      enable:'Enable',
      shutdown:'Shutdown',
      restart:'Restart',
      ring:'Device Ringing',
      device_reset:'Restore Device',
      get_device_logs:'Extract Logs',
      ring_pwd:'Password',
      ring_modal_total:'Tip',
      ring_modal_total1:'Device will ring with the largest volume and will stop when enter the password',
      ring_modal_total2:'Password for stop',
      ring_modal_total3:'Please enter the 4 digital number',
      ring_modal_total_true:'Yes',
      ring_modal_total_false:'No',
      confirm:'OK',
      cancel:'Cancel',
      device_img:'device',
      device_info:'Device Information',
      device_status:'Device status',
      on_line:'Online',
      off_line:'Offline',
      on_work:'Normal',
      disable_tip:'This operation will disable the device, do you want to continue?',
      enable_tip:'This operation will unlock the device, do you want to continue?',
      shutdown_tip:'This operation will shut down the device, do you want to continue?',
      restart_tip:'This operation will restart the device, do you want to continue?',
      ring_tip:'This operation will make the device ring, do you want to continue?',
      reset_tip:'This operation will restore the device to factory settings, do you want to continue?',
      get_log_tip:'This operation will extract the device log, do you want to continue?',
      close:'Close',


      task_code:'Task number',
      task_type:'Type',
      task_name:'content',
      task_status:'execution status',
      release_time:'release time',
      execution_time:'execution time',
      app_deploy:'Application Deployment',
      wifi_config:'WIFI configuration',
      apn_config:'APN configuration',
      function_config:'Function Settings',
      param_config:'parameter configuration',
      file_distribution:'File distribution',
      message_send:'Message Push',
      fence_config:'geo fence',
      custom_desktop:'Custom Desktop',
      get_device_log:'Extract device log',
      occupy_screen_log:'Occupy Screen',
      app_black_list:'App blacklist',
      boot_animation:'Boot Animation',
      boot_logo:'Boot Logo',

      task_executing:'Under execution',
      task_executing_fail:'Exec failure',
      task_executing_success:'Executed',
      org_name:'Merchant',
      device_task_log:'Terminal task log',


      //Power related
      power_mobile_network:'Mobile network standby',
      power_screen:'Screen',
      power_blueTooth:'Bluetooth',
      power_system:'System',
      phone_standby_power:'Phone standby',
      power_wifi:'WIFI',
      current_power:'Current power::',
      power_consumption_ratio:'Power Consumption Ratio',
      power_consumption:'Power Consumption',
      acquisition_time:'Acquisition Time',
      power_recharge:'Charge',
      power_discharge:'discharge',
      device_power:'Power',
      device_power_update_time:'Update time',

      device_type_no_select:'Please select a model',
    },
    //厂商相关
    manufacturer:{
      addManufacturer:'Add a manufacturer',
      confirm:'OK',
      cancel:'Cancel',
      enter_manufacturer_name:'Maximum 100 characters',
      enter_manufacturer_dvc_type:'Maximum 25 characters',
      remove_manufacturer_type_tip1:'Are you sure you want to delete',
      remove_manufacturer_type_tip2:'Model number? ',

      remove_manufacturer_tip1:'Are you sure you want to delete',
      manufacture_name_empty:'Manufacturer cannot be empty',
      dvc_type_empty:'The device type cannot be empty',
      manufacturer_name:'Manufacturer name:',
      dvc_type:'Device type:',


    },
    form : {
      play:'Play',
      finish_time0_1:'Finish time',
      record_time: 'Record time',

      restore_record_remark:'After the device has left the geofence for a period of time, the factory settings will be restored',
      restore_record_remark_front:'The device leaves the geofence',
      restore_record_remark1:'Disable device',
      restore_record_remark2:'Disable mobile network',
      record_warn: 'Warning',
      enter_limit_time_chaochu: 'The maximum time limit is 7 days',
      enter_limit_time_error: 'Please enter a positive integer',
      enter_limit_time: 'Please enter the limit time',
      select_time_danwei: 'Please select the time unit',
      limit_minute:'minute',
      limit_hour:'hour',
      restore_tip: 'Tips',
      tip_of_restore_device_data: 'After the device leaves the geofence for a specified time, restore the factory settings',
      limit_time: 'Limited time',
      save_success:'Operate Success',
      app_deploy_manage:'App Deployment',
      app_white_list:'App Whitelist',
      app_black_list:'App Blacklist',
      to_deploy_app:'deploy app',
      black_list:'Black list',
      tree_empty:'No Data',
      deploy_push_manage:'Push Manage',
      deploy_name:'Name',
      deploy_type:'Type',
      deploy_push_circle:'Push Range',
      deploy_schedule:'Execution Progress',
      deploy_status:'Push Status',
      deploy_operate:'Action',
      deploy_add:'Add',
      deploy_name_not_empty:'Please input name',
      deploy_type_not_empty:'Please select mode',
      deploy_autoRun_not_empty:'Please select Auto Run',
      deploy_time_not_empty:'Please select Deploy Time',
      deploy_operation_success:'operation success',
      deploy_autoRun_error:'Only one app can be selected for Auto Running. Please reselect the app',
      deploy_enable_uninstall_empty:'Please select weather enable uninstall',
      default_app_deploy_name:'My application configuration',
      deploy_must_input:'Required Field',
      deploy_must_select:'Required Field',
      deploy_delete:'Delete',
      deploy_select_app:'Select App',
      deploy_install_mode0:'Silent installation',
      deploy_install_mode1:'Download And Prompt',
      deploy_auto_run:'Auto Runing',
      deploy_auto_run_mode0:'YES',
      deploy_auto_run_mode1:'NO',
      deploy_auto_run_type:'Please choose to run automatically',
      deploy_app_edit_modal:'Edit App Deploy',
      deploy_current:'Deploy now',
      deploy_app_mode:'Deploy mode',
      deploy_app_interval:'Deploy Time',
      deploy_app_uninstall:'Enable Uninstall',
      deploy_app_uninstall_true:'True',
      deploy_app_uninstall_false:'False',
      deploy_app_push:'Push',
      deploy_app_edit:'Edit',
      deploy_delete_rule:'Are you sure you want to delete the deployment rule?',
      deploy_record:'Log',
      deploy_delete_tip:'Tip',
      deploy_unfinish_sn:'Unfinish SN：',
      noneDvcType: 'The device type that needs to be set is not found',
      custom_desk_add:'Add Custom Desktop',
      deskAttention: 'Note: Customized desktop will be checked and downloaded when the device starts or restarts. If your user uses SIM to connect to the network, please pay attention to the traffic consumption caused by downloading the desktop. ',
      getDeskDetailFailed: 'Failed to get desktop details',
      deskSelectFailed: 'Desktop Selection Failed',
      deskSelectSuccess: 'Desktop Selection Succeeded',
      deskUsingNow: 'The desktop is in use',
      btnUse: 'Use',
      explanation : 'Explanation',
      selected: 'Selected',
      deskDetail: 'Desktop Details',
      sysDefaultDesk: 'System Desktop (default)',
      clear_oprate : 'Delete Unlock Password',
      recover_operate : 'Reset',
      last_use_time : 'Time of Last Use',
      last_use_address : 'Address of Last Use',
      clp_tip : 'After the password is cleared, app data will not be lost but the password will not be recovered. Continue or not? ',
      recover_tip : 'After restoring factory settings,the device will return to its original state.Continue or not?',
      usage_operator : 'Operator',
      remark : 'Remarks',
      task_progress : 'Task Progress',
      device_group_name : 'Device group name',
      device_set_wifi: 'WiFi Configuration',
      device_get_log: 'Device Log',
      clear_password : 'Clear Password',
      usage_recover : 'Recover',
      usage_restart : 'Restart',
      usage_shotdown : 'Shutdown',
      usage_file_send : 'Files Distribution',
      usage_uninstall_app : 'Uninstall App',
      usage_end_time : 'End Time',
      usage_start_time : 'Start Time',
      usage_ope_type_select : 'Select Operating Type',
      usage_sn_query : 'Enter SN',
      app_grayscale_view: 'View Grayscale Range',
      app_grayscale_nosn: 'No Device in Grayscale Range',
      app_grayscale_change: 'Adjust Grayscale Range',
      app_grayscale_clearall: 'Clear All',
      app_grayscale_tip1: 'Please select the device and then confirm',
      app_grayscale_tip2: 'No Eligible Devices',
      app_grayscale_confirm: 'OK',
      app_delete_all: 'You are about to delete this app. Are you sure you want to delete it? ',
      app_banner_url_max: 'The maximun length of the link is 500 characters http://',
      app_publish_sn_cancel : 'Data is not saved. Leave or not? ',
      app_upgrade : 'Update the App',
      app_set_gray_range: 'Set the Grayscale Range',
      app_upgrade_note : 'Notes for Upgrade',
      ajust_gray_deploy : 'Adjust Grayscale',
      app_all_deploy : 'All Deployed',
      app_gray_upgrade : 'Grayscale Upgrade',
      app_remarket : 'Remarks:',
      app_upload_desPicture : 'Describe the Picture',
      app_deploy : 'Deploy:',
      upgrade_curr_total : 'Number of Machines Updated',
      app_publish_time : 'Publish Date',
      app_version_code : 'Version Code',
      app_version_note : 'Notes to Version',
      normal_upgrade : 'Normal Upgrade',
      coverage_upgrade : 'Coverage Upgrade',
      to_formal_edition : 'Turn to the Official Version',
      restore_issue : 'Restore the Issue',
      pause_issue : 'Pause the Issue',
      gray_packge : 'Grayscale Package',
      formal_package : 'Official Package',
      app_review_ing : 'Under Review',
      app_review_yes: 'Review Succeeded',
      app_review_no: 'Review Failed',
      app_publish_no : 'Not Published',
      app_publish_yes : 'Has been Published',
      full_channel : 'Full Channel',
      curr_channel : 'Current Channel',
      app_publish_channel_way : 'Publish App Channel',
      app_publish_status : 'Publish Status',
      app_desc_pic_upload: 'Upload Image Description: ',
      app_desc_pic_checkout: '(Upload Size: 720*1280; Format: png, jpg; Size: no more than 5M)',
      app_apk_upload: 'Click or drag the installation package to upload here',
      app_add_device: 'Add SN',
      device_search_tip : 'Enter Keywords',
      device_distribute_batchBind: 'Distribute in Batches',
      device_distribute_batchUnbind:'Collect in Batches',
      device_distribute_selectSubAccount: 'Please select the sub-account',
      no_match:'No Matching Data',
      device_distribute_enterSn: 'Please enter the SN number',
      device_distribute_enterSn2:'Enter SN',
      device_distribute_add: 'Add',
      device_distribute_download: 'Download Template',
      device_distribute_batchImport: 'Import in Batches',
      device_distribute_dragTip: 'Click or drag your form here to upload',
      device_distribute_totalNum: 'Total Number',
      device_distribute_unbindNum: 'Unbound',
      device_distribute_unexistNum: 'Do not Exist',
      device_distribute_isFreezeNum: 'Freeze',
      device_distribute_repeatNum: 'Invalid Repeat',
      device_distribute_not_bind:'Unbound',
      device_group_grouped:'Grouped',
      device_group_unGrouped:'UnGrouped',
      device_distribute_cancel: 'Cancel',
      device_distribute_confirmBind: 'Confirm Binding',
      device_distribute_confirm: 'OK',
      device_distribute_serialNum: 'No.',
      device_distribute_errorRow: 'Number of wrong lines',
      device_distribute_di: 'Line ',
      device_distribute_row: '',
      device_distribute_errorReason: 'Reason for errors',
      device_distribute_devType: 'Device Type',
      device_jd_type:'Type',
      device_group_code:'Device Group Name',
      device_distribute_subAccount: 'Sub-account',
      device_distribute_status: 'Status',
      device_distribute_tip1: 'Please import the device number to be bound',
      device_distribute_tip2: 'No eligible devices to be bound',
      device_distribute_tip3: 'No eligible equipment is available',
      device_distribute_tip4: 'No eligible equipment to be associated',
      device_donaterecord_unFinished: 'In Processing',
      device_donaterecord_searchTip: 'Enter SN Number',
      device_donaterecord_startTime: 'Start Time',
      device_donaterecord_endTime: 'End Time',
      device_donaterecord_donateType: 'Type',
      device_donaterecord_all: 'Uninstall by application package name',
      device_donaterecord_search: 'Search',
      device_donaterecord_finished: 'Finished',
      device_donaterecord_result: 'Result',
      device_donaterecord_snNo: 'SN Number',
      device_donaterecord_operateTime: 'Operation Time',
      device_donaterecord_alreadyReject: 'Reception Rejected',
      device_donaterecord_alreadyRecept: 'Successfully received',
      device_donaterecord_alreadyRevoke: 'Donate Revoked',
      device_donaterecord_unknown: 'Unknown',
      device_donaterecord_accept: 'Accept',
      device_donaterecord_donate: 'Transfer',
      device_donaterecord_revoke: 'Revoke the Donate',
      device_donaterecord_acceptDonate: 'Successfully Accept',
      device_donaterecord_refuseDonate: 'Reject to Accept',
      device_donaterecord_partnerAcceptDonate: 'The Partner Accepts',
      device_donaterecord_partnerRefuseDonate: 'The Partner Refuses',
      device_donaterecord_donateTime: 'Donate Initiation Time',
      device_donaterecord_dateTimeTip1: 'Please select the start time',
      device_donaterecord_dateTimeTip2: 'Please select the end time',
      device_donaterecord_dateTimeTip3: 'The start time is greater than the end time. Please re-select',
      device_donaterecord_dateTimeTip4: 'The interval cannot be greater than 30 days',
      device_donaterecord_revoke2: 'Revoke',
      device_donaterecord_confirmRevokeTip: 'Confirm to revoke the donate of this device, continue or not? ',
      device_donaterecord_confirmReceptTip: 'Confirm to accept this device, continue or not? ',
      device_donaterecord_confirmRejectTip: 'Confirm to reject this device, continue or not? ',
      device_donaterecord_reject: 'Reject',
      device_donate_batchDonate: 'Transfer in Batches',
      device_donate_enterTip1: 'Please enter the Company ID',
      device_donate_enableDonateNum: 'Enable Donate',
      device_donate_receiver: 'Receiver',
      device_donate_receiverTip1: 'Please enter the company ID',
      device_donate_tip1: 'The donate will be irrevocable after being accepted by the other party. Please donate after confirming the recipient',
      device_donate_confirm: 'Confirm Donate',
      device_donate_checkCompanyInfo: 'Check the recipient information',
      device_donate_companyName: 'Receiver Name',
      device_distribute_freeze: 'Device is Frozen',
      device_distribute_skip_level:'The device is a cross-level sub-account',

      device_group_check_tip1_no:'Please select the group first .',
      device_group_checked_tip_no:'Please tick a device group',
      device_group_checked_tip:'Tick up to one device group',
      device_group_multiple_tip:'Cannot move to the same device group',
      device_group_move_tip:'Move all the devices in this group to the selected group',
      device_group_administrator:'Administrator',
      device_group_administratorName:'Administrator Name',
      device_group_enter_groupName:'Group name (required)',
      device_group_enter_groupName_tip:'Please enter Group Name!',
      device_group_enter_locationInfo:'location information (optional)',
      device_group_enter_name:'Name (optional)',
      device_group_enter_contacts:'Email/phone (optional)',
      device_group_enter_remarks:'Remarks (optional)',
      device_group_contacts:'Contacts',
      device_group_deviceCount:'Device Count',
      device_group_tools_details:'Total number of direct terminals and sub-packet terminals',
      device_group_deviceTotalCount:'Total Device Count',
      device_group_address:'Location Information',
      device_group_quCode:'Qr Code',
      device_group_quCodeDetail:'You can scan the qrCode to change the group of device by using "App market"-"Setting"-"Scanning"',
      device_group_associateDevice:'Bound Devices',
      device_group_associateDevice2:'Bound Devices',
      device_group_exportDevice:'Import Devices',
      device_group_deviceMove:'Migration',
      device_group_batchManage:'Batch Manage',
      device_import_notes:'Import Notes',
      device_group_importGroup:'Import',
      device_group_exportGroup:'Export',
      device_group_name2: 'Group Name',
      device_group_allDevice: 'All Devices',
      device_group_all_group:'All Groups',
      device_group_add: 'Add a Device Group',
      device_group_tip1: 'Please enter the name of device group',
      device_group_update: 'Modify the Name of Device Group',
      device_group_confirm: 'Confirm',
      device_group_tip2: 'Please enter the name of device group and then confirm',
      device_group_total: 'Total Devices:',
      device_group_online_total: 'Devices Online:',
      device_groupDevice_alreadySelect: 'Selected',
      device_groupDevice_tip1: 'Pieces',
      device_groupDevice_batchOper: 'Operate in Batches',
      device_groupDevice_disable: 'Freeze the Device',
      device_groupDevice_undisable: 'Unfreeze the Device',
      device_groupDevice_moveto: 'Move to',
      device_groupDevice_uninstallApp: 'Uninstall the Apps',
      device_groupDevice_fileDistribution: 'Files Distribution',
      device_groupDevice_extractDeviceLogs: 'Extract Device Log',
      device_groupDevice_scanLogs: 'View Log',
      device_groupDevice_wifiSetting: 'WiFi Configuration',
      device_groupDevice_shutDown: 'Shutdown',
      device_groupDevice_restart: 'Restart',
      device_groupDevice_ring:'Device Ring',
      device_groupDevice_extract_dvc_logs: 'Extract The Device Log',
      device_groupDevice_wifi_conf: 'WiFi Configuration',
      device_groupDevice_operate: 'Operate',
      device_groupDevice_number: 'Quantity',
      device_groupDevice_progress: 'Progress',
      device_groupDevice_detail: 'Details',
      device_groupDevice_confirm2: 'OK',
      device_groupDevice_confirm3:'Edit',
      device_groupDevice_wifiSetting_tip: 'WIFI Remote Configuration',
      device_groupDevice_apnSetting_tip:'APN Add Setting',
      device_groupDevice_edit_apnSetting_tip:'APN Edit Setting',
      device_groupDevice_view_apnSetting_tip:'APN View Setting',
      device_groupDevice_tip2: 'Only one Application can be Uninstalled at a Time',
      device_groupDevice_uninstallType: 'Uninstall Method:',
      device_groupDevice_appPackageName: 'App Package Name:',
      device_groupDevice_appConfigName:'Configuration name:',
      device_groupDevice_tip3: 'Fill in the name of the application package to be uninstalled. Only one is allowed (for example: ffsdsssd.dasdasd.sadasd)',
      device_groupDevice_tip4: 'Please confirm the accuracy of the package name',

      device_groupDevice_config_version:'Version：',
      device_groupDevice_configName:'Configuration name：',
      device_groupDevice_tip_inputConfigName:'Please fill in the configuration name',
      device_groupDevice_configName_input:'Please fill in the configuration name',
      device_groupDevice_appName: 'App Name:',
      device_groupDevice_tip5: 'Please select the app name',
      device_groupDevice_version: 'App Version:',
      device_groupDevice_tip6: 'Please select the app version',
      device_groupDevice_next:'Next',
      device_groupDevice_cancel: 'Cancel',
      device_groupDevice_tip7: 'Only one file can be distributed in batches at a time',
      device_groupDevice_fileUpload: 'File Upload:',
      device_groupDevice_uploadFile: 'Upload File',
      device_groupDevice_tip8: 'The file size shall not exceed 100M. The distributed file cannot be revoked. Please be careful!',
      device_groupDevice_targetPath: 'Target Path:',
      device_groupDevice_tip9: 'Format is: /sdcard/MDM',
      device_groupDevice_tip10: 'Specified path of the file storage at device side as specified above!',
      device_groupDevice_fileRule: 'File Rule:',
      device_groupDevice_deviceGroup: 'Device Grouping',
      device_groupDevice_uninstallAppTip: 'After the task of [Uninstall application] expires',
      device_groupDevice_uninstallAppName: 'Name of Uninstalled App:',
      device_groupDevice_uninstallAppPackageName: 'Name of uninstalled app package:',
      device_groupDevice_tip11: 'Enter SN Number to Search',
      device_groupDevice_refresh: 'Refresh',
      device_groupDevice_revoke: 'Revoke',
      device_groupDevice_shutDownTip: 'After the [Shutdown] Task Expires',
      device_groupDevice_retry: 'Retry',
      device_groupDevice_restartTip: 'After the [Restart] Task Expires',
      device_groupDevice_fileDistributionTip: 'After the [File Distribution] Task Expires',
      device_groupDevice_wifiSettingTip: 'After the [WiFi configuration] Task Expires',
      device_groupDevice_extractDvcLogsTip: 'After the [Extract Device Log] Task Expires',
      device_groupDevice_fileName: 'File Name:',
      device_groupDevice_fileSize: 'File Size:',
      device_groupDevice_isCoverYes: 'Cover or not: Yes',
      device_groupDevice_isCoverNo: 'Cover or not: No',
      device_groupDevice_isRemindYes: 'Remind the other party or not: Yes',
      device_groupDevice_isRemindNo: 'Remind the other party or not: No',
      device_groupDevice_uninstallType1: 'Uninstall by App Name',
      device_groupDevice_uninstallType2: 'Uninstall by Package Name',
      device_groupDevice_deviceStatus: 'Status',
      device_groupDevice_deviceZhuangTai:'Device Status',
      device_groupDevice_deviceStatus1: 'Online',
      device_groupDevice_deviceStatus2: 'Offline',
      device_groupDevice_deviceType: 'Device Type',
      device_groupDevice_deviceRemarks:'Remarks',
      device_groupDevice_deviceLocation:'Location',
      device_groupDevice_deviceNetwork:'Network',
      device_groupDevice_deviceBattery:'Battery',
      device_groupDevice_deviceBanStatus:'Permission',
      device_groupDevice_deviceXingHao:'Device Type',
      device_groupDevice_dvcId: 'SN Number',
      device_groupDevice_dvcSn:'Device SN',
      device_groupDevice_lastRequestTime: 'Last Connection',
      device_groupDevice_coverOriginal: 'Cover the Original File',
      device_groupDevice_tip12: 'Remind the other party after successful download',
      device_groupDevice_executing: 'In Queue',
      device_groupDevice_executeSuc: 'Successful Executed',
      device_groupDevice_executeFail: 'Failed Execution',
      device_groupDevice_groupName: 'Group Path',
      device_groupDevice_time: 'Time',
      device_groupDevice_executing2: 'To be Executed',
      device_groupDevice_tip13: 'Please enter the SN number',
      device_groupDevice_tip14: 'No record of this device',
      device_groupDevice_tip15: 'Please upload the files that need to be distributed!',
      device_groupDevice_tip16: 'Please enter the correct target path!',
      device_groupDevice_tip17: 'Please input the name of the app package to be uninstalled',
      device_groupDevice_tip18: 'Please select the name of the app to be uninstalled',
      device_groupDevice_tip19: 'Please select the version of the app to be uninstalled',
      device_groupDevice_ssid_tip: 'Please enter the Service Set Identifier (SSID)',
      device_groupDevice_operate_tip:'Please select operate type',
      device_groupDevice_group_tip:'Please check group',
      device_groupDevice_banStatus_normal:'Normal',
      device_groupDevice_banStatus_prohibited:'Prohibited',
      device_groupDevice_banStatus_prohibited_msg:'You can type the message for prohibiting , length of should less than 150',


      device_remote_wifiSetting_ssid: 'Service Set Identifier(SSID)',
      device_remote_wifiSetting_ssid_allow:'Only Allow this SSID',
      device_remote_wifiSetting_ssid_allow_tip:'Only allowed to connect to the SSID issued by the device terminal',

      device_remote_wifiSetting_ssid_tip: 'WIFI name to connect',

      device_remote_wifiSetting_hide: 'Hide Network',
      device_remote_wifiSetting_hide_tip: 'When the target network is not open or signals are not broadcast, please enable this feature',
      device_remote_wifiSetting_autoJoin: 'Automatically Join',
      device_remote_wifiSetting_autoJoin_tip: 'Automatically join this wireless network',
      device_remote_wifiSetting_safeType: 'Security Protocol',
      device_remote_wifiSetting_safeType_tip:'Wireless network encryption type used when connecting',
      device_remote_wifiSetting_pwd: 'Password',
      device_remote_wifiSetting_pwd_tip: 'Password of the access point',

      //  功能设置
      device_groupDevice_FunctionSetting_tip:'Add Function Setting',
      device_groupDevice_FunctionSetting_edit_tip:'Update Function Setting',
      device_remote_rule_name:"Rule Name",
      device_remote_fcSetting_bluetooth_disable: "Bluetooth Disable",
      device_remote_fcSetting_wifi_disable: "WIFI Disable",
      device_remote_fcSetting_MobileTraffic_disable: "MobileTraffic Disable",
      device_remote_fcSetting_ThirdPartyApplicationInstallation_disable: "ThirdPartyApplication Installation Disable",
      device_remote_fcSetting_camera_disable: "Camera Disable",
      device_remote_fcSetting_tel_disable: "Tel Disable",
      device_remote_fcSetting_message_disable: "Message Disable",
      device_remote_fcSetting_gps_disable: "GPS Disable",
      device_remote_fcSetting_adb_disable: "ADB Disable",
      device_remote_fcSetting_usb_disable: "USB Disable",
      device_remote_fcSetting_home_disable: "Home Disable",
      device_remote_fcSetting_dropDown_disable: "DropDown Disable",
      device_remote_fcSetting_input_disable: "Input Disable",
      device_remote_fcSetting_restoreFactory_disable: "RestoreFactory Disable",
      device_remote_fcSetting_sd_disable: "SD Disable",
      function_setting_push:'Function Setting Push Range',

      function_ruleName:"The ruleName can not be null",

      myFunctionSetting:'My Function Setting',
      myWifiSetting:'My WIFI Setting',
      wifiNameNotSame:'The WIFI setting name cannot be repeated',
      customDeskNameNotSame:'The Custom Desktop Name can not be repeated',



      function_pushRange:"The pushRange can not be null",
      function_push_confirm:"Confirm to push the following range?",
      function_push_histroy_content:"The History Content of Function Setting",
      delete_function_config_batch:'Delete FunctionConfig',
      delete_function_config_batch_tip:'Delete the Function configuration, and the configuration information on the device side is also deleted. The device restores the original settings. Is it deleted?',
      on:'ON',
      off:'OFF',

      close: 'Close',
      open: 'Open',
      companyName: 'Company Name',
      companyAddress: 'Company Address',
      companyShortName: 'Company Abbreviation',
      companyWebsite: 'Company Website',
      countryCode: 'Country/Region',
      companyPrincipal: 'Company Contact Person',
      companyArea: 'Company Area',
      companyEmail: 'Company Mailbox',
      companyCredential: 'ID Card / Company Credential',
      companyTel: 'Contact Phone',

      company_name_rule: 'Please enter the company name',


      default : 'Default strategy',
      app_packagename_tip: 'Package Name Prevails',
      delete_success : 'Delete Successfully',
      username : 'Account',
      nickname : 'Name',
      password : 'Password',
      default_password : 'The default password is 908070',
      defpass : 'The default password is One@908070',
      email : 'Email',
      tel : 'Contact',
      sex : 'Gender',
      type : 'Type',
      type_all : 'All',
      type_platform : 'Platform User',
      type_pda : 'End User',
      sexfemale : 'Female',
      semmale : 'Male',
      job : 'Job',
      description : 'Description',
      lastupdatetime : 'Last Update Time',
      lastupdateuser: 'Last Update Operator',
      submit : 'Submit',
      reset : 'Reset',
      return : 'Return',
      avatar: 'Avatar',
      aaveupdate: 'Save Updates',
      avatarupload : 'Avatar Upload',
      avatarchange : 'Avatar Change',
      oldpassword : 'Current Password',
      newpassword : 'Set a New Password',
      pleaseinputnewpassword: 'Please enter a new password',
      newpasswordtip : 'New password -- need to log in again after update! ',
      confirmnewpassword : 'Repeat the new password',
      organizationname : 'Organization Name',
      uploadNode: 'Upload Organization Name',
      organization_1 : 'Organization',
      selectorganization : 'Please select an organization',
      selectOrgTip: 'The bottom layer can not add organizations',
      user_search_tip : 'Account/Name/Organization Name',
      user_chirld_account: 'Please enter the sub-account name',
      search : 'Search',
      addPlatformUser : 'Add user', // 'Add platform user',
      addPDAUser : 'Add end user',
      editUser : 'Edit user',
      batchdel : 'Delete in batches',
      batchdel_confim : 'Confirm deletion',
      reminder : 'Notice',
      lockTip0: 'Caution: After confirm this step, the system will enter KIOSK mode and this application, "',
      // lockTip1: ', The locked app under this device type will be unlocked. Continue or not? ',
      lockTip1: '", will be shown at the top layer. Password would be requested when exiting the KIOSK mode.',

      fourPwd: 'Please enter 4 significant digits',
      unlockTip0: 'Notice: System will exit KIOSK mode and the application, "',
      unlockTip1: '", will not show on the top layer any more. Please confirm.',
      removeOccupyApp0: 'You will disable Kiosk mode of ',
      removeOccupyApp1: ' on ',
      removeOccupyApp2: ', Continue or not? ',
      batchdel_confim_tip : 'Confirm to delete these users. Continue or not? ',
      batchdelone_confim_tip : 'Confirm to delete this user. Continue or not? ',
      batchlogout_confim_tip : 'Confirm to log out. Continue or not? ',
      batchh_return_parent_account_tip: 'Return to the parent account. Continue or not? ',
      device_binding: 'Distribute',
      device_unBingding: 'Unbind',
      device_change_subaccount: 'Replace the Sub-account',
      device_binding_subaccount: 'Distribute to the subaccount',
      resetpass : 'Reset the Password',
      editpass: 'Change the Password',
      updatepass : 'Update the Password',
      confirmresetpass_tip : 'This operation will reset the password as One@908070.',
      continue : 'Continue or not? ',
      status : 'Status',
      status_normal : 'Normal',
      status_deleted : 'Deleted',
      status_locking : 'Locking',
      operation : 'Operation',
      wait_operate: 'To be Executed',
      operate_success: 'Successful Executed',
      operate_fail: 'Failed Execution',
      subordinate_account : 'Device Owner',
      children_account:'Sub-account',
      nooperation : 'No Operation',
      noauthtips: 'Super administrator, no permission to operate',
      nooperationtips: 'Current login user, no operation',
      selectmoreone : 'Please select a item first',
      selectgroup : 'Please tick the group',
      selectone: 'Please select an app',
      deleteDisabledMDM: 'Cannot delete MDM app',
      outofauthority: 'Devices outside the authority. Please re-select',
      alreadyDisabled: 'Already disabled. Please re-select',
      noNeedUnforbidden: 'No need to lift the ban. Please re-select',
      noOrderRight: 'Cannot execute this order. Please re-select',
      alreadyBelongOrg: 'Already belongs to the current selected agency',
      occupyScreenForPdaToptips: 'Under KIOSK mode, please long press "Back" key of navigation bar for going back.',
      setOccupyScreenModel: 'Set to Kiosk',
      setSilentAppModel: 'Set default start',
      silent_query_appname:'Enter an APP name',
      edit : 'Edit',
      update : 'Update',
      lock : 'Lock',
      passwordEdit : 'Change password',
      restoration: 'Return to normal state',
      passedit: 'Change password',
      pleaseSelectnode: 'Please select an organization',
      batchlock_confim : 'Lock confirmation',
      batchlock_confim_tip : 'This operation will lock the user',
      unlock : 'Unlock',
      delete : 'Delete',
      recovery : 'Recovery',
      batchrecovery_confim : 'Restore confirmation',
      batchrecovery_confim_tip : 'Confirm that the user is restored to the normal status. Continue or not? ',
      id : 'ID',
      lastloginip: 'Last login ip',
      lastlogintime: 'Last login time',
      role : 'Role',
      role_p : 'Role permissions',
      auth: 'Authority',
      add : 'Add',
      addOrg: 'Add a new organization',
      organizationid : 'Organization number',
      organizationias : 'Organization abbreviation',
      organizationadmin : 'Organization administrator',
      organizationadmin_tips: 'Current organization’s super administrator. Password is One@908070. Add synchronously with the organization!',
      organizationprincipal : 'Organization contact person',
      organizationdescription : 'Organization description',
      organizationaddress : 'Organization address',
      administratorNum: 'Number of administrators',
      deviceNum: 'Number of devices',
      addDeviceByQR: 'Add the QR code device',
      strategyInfo: 'Strategy details',
      QR_adddevice: 'Scan the QR code to add a device',
      QR_tip: 'Use the terminal device to scan this QR code and the device can bind by itself',
      QR_download: 'QR code download',
      visableApplication: 'Visible application',
      lookVisableApplication: 'View visible application',
      deviceStrategy: 'Device Strategy',
      configStrategy: 'Configuration Strategy',
      fenceStrategy: 'Fence Strategy',
      defaultStrategy: 'Default Strategy',
      otherStrategy: 'Other Strategies',
      strategyOwnOrg: 'Organization that owns the strategy',
      noPublishOrg: 'No organization assigned',
      noApply: 'No Application',
      publishStrategy: 'Assign',
      noStrategy: 'Default Strategy',
      inoperatable: 'Sorry. You have no permission to operate this organization! ',
      editDisable: 'Warning: this strategy is outside the scope of your permission operation, and the restriction function is not editable! ',
      editDisable2: 'Warning: the restriction function of the default strategy is not editable! ',
      confimorganizationdelete : 'Please confirm that all data under this organization has been cleared. Continue to delete or not?',
      tip : 'Tip',
      warmTip: 'Warm Tips',
      btnsave : 'Save',
      btnsubmit : 'Submit',
      btncancel : 'Cancel',
      btnreset : 'Reset',
      checkall: 'Check All',
      parent : 'Parent',
      deviceMoveToOrg: 'Affiliated Organization',
      occupyScreenPwdTip: ' Current Kiosk unlock password (4 digits numbers )',
      appname : 'App Name',
      appurl : 'App Url',
      applogo : 'App Logo',
      appIcon : 'App Icon',
      appIconCheckout: '(Size: no more than 100KB, Dimension: 140*140 pixels, Image Format: PNG/JPG)',
      appIconCheckout_size:'Size: no more than 100KB',
      appIconCheckout_pix:'Dimension: 140*140 pixels',
      appIconCheckout_format:'Format: PNG/JPG',
      appDesc: 'App Description',
      descriptionhint2: 'Please fill in the application description',
      bussType: 'Catalog',
      apppackage : 'Package Name',
      appversion: 'Version',
      pubDitch: 'Publishing Coverage',
      allDitch: 'Global',
      selfDitch: 'This Account',
      deployType: 'Deployment Type',
      settings2: 'Set',
      allDeploy: 'All Deployed',
      grayDeploy: 'Grayscale Deployment',
      appversioncount: 'Number of Versions',
      device_sn : 'Device SN Number',

      groupshelf1:'Add Partially',
      groupshelf:'Group shelf',
      shelfrevise:'Adjust',
      appforce : 'Auto Install',
      appsize : 'Size',
      ShelfDvcType: 'Available Model',
      versionState: 'Version Description',
      appDescPic: 'Product Screenshot',
      appversioncode : 'Version Number',
      appversionname : 'Version Name',
      appDownloadNum:'Downloads',
      appid : 'Application ID',
      applanguage : 'Language',
      appfeature : 'Update Information',
      appnamehint : 'Please Enter 1-20 Characters',
      descriptionhint : 'Please Enter 0-300 Characters',
      appfeaturehint : 'Please Enter 0-200 Characters',
      appproducerhint: 'Please Enter 0-50 Characters',
      appproducer: 'Producer',
      appdescmaxlength : 'Please Enter no more than 1000 Characters!',
      appproducerLength : 'Please Enter no more than 100 Characters!',
      uploadtime : 'Upload Time',
      updatetime : 'Update Time',
      uploaduser : 'Upload User',
      updateuser : 'Update User',
      distributionorganization: 'Distribution Organization',
      distributiondev: 'Distribution Device',
      app_search_tip : '@:yd.form.appname',
      keyword_for_search: 'Enter Keywords',
      appversionlist : 'App Version List',
      viewallappversion : 'View All Versions',
      viewall: 'View',
      grant: 'Grant',
      appgrant: 'Grant App',
      regrant: 'Re-grant',
      regrant2: 'Re-grant',
      yes: 'Yes',
      no : 'No',
      synchronous: 'Synchronous',
      unsynchronous: 'Unsynchronous',
      confirmappdelete : 'This operation will remove the app. Continue or not?',
      confirmdeleteappfromdevice : 'Is the application on the device deleted synchronously?',
      confirmdeleteappfromdevice2 : 'This operation will delete the terminal application data. Are you sure to delete?',
      upperapp : 'Application at the upper layer',
      shelf : 'Shelf',
      unshelf : 'Unshelf',
      appshelf : 'Add Apps',
      appunshelf : 'Remove Apps',
      uploadapk : 'Upload APK',
      editbaseinfo : 'Edit basic information',
      selectype: 'Select type',
      confirmupload : 'Confirm to upload',
      uploadapk_tip : 'Click or drag your APK here and upload',
      uploadapk_tip2 : '',
      chinese : 'Chinese',
      english : 'English',
      scope : 'Scope',
      public : 'Public',
      private : 'Private',
      next : 'Next',
      previous : 'Previous',
      finish : 'Finish',
      publish : 'Publish',
      canpublish : 'Publishable app',
      haspublished : 'Published app',
      notpublished : 'Unpublished app',
      appversionlower : 'App version is too low',
      confirmappshelf_tip : 'This operation will push the app to the device. Continue or not?',
      confirmappunshelf_tip : 'This operation will remove the app from the device. Continue or not?',
      content : 'Message content',
      msg_title : 'Message title',
      owner : 'Owner',
      strategy_data_send: 'Send data',
      strategy_function_limit: 'Function limit',
      strategy_call_limit: 'Call limit',
      strategy_app_blacklist: 'App blacklist',
      strategy_app_nessary: 'Necessary apps and update',
      strategy_safeDesk: 'Safe desktop',
      strategy_hideIcon: 'Hide app icon',
      strategy_geo_fence: 'Geographic fence',
      strategy_wifi_config: 'WIFI remote configuration',
      strategy_wifi_control: 'WIFI remote control',
      strategy_wifi_blacklist: 'WIFI blacklist',
      strategy_voice_limit: 'Volume control',
      strategy_limit_tip: 'The following restrictions will only take effect if the device os version meets Android 5.1 version',
      strategy_hotspot: 'Mobile hotspot',
      strategy_usb_debug: 'USB Debugging',
      strategy_app_install: 'App install',
      strategy_call_blacklist: 'Phone blacklist',
      strategy_open_callService: 'Remotely turn on phone services',
      strategy_close_callService: 'Remotely turn off phone services',
      strategy_blacklist_tip: 'Blacklist reminder',
      strategy_window_blacklist_tip: 'Does the device pop up a window to prompt to disable the blacklist phone',
      strategy_window_blacklist_tip2: 'Does the device pop up a window to prompt to disable the blacklist application',
      strategy_prompt_yes: 'Prompt',
      strategy_prompt_no: 'No prompt',
      strategy_use_yes: 'Use',
      strategy_use_no: 'Do not use',
      telephone_enter_tip: 'Please enter a phone number',
      strategy_add_appblacklist: 'Add an app on the blacklist',
      strategy_enter_packageName: 'Package name length is 1-60 bits, consisting of numbers, letters, underscores and .',
      strategy_enter_appName: 'App name length is 1-20 digits',
      strategy_necessary_app: 'Necessary app',
      strategy_necessary_tip: 'Necessary app cannot be uninstalled',
      strategy_necessary_tip2: 'App installation status feedback',
      strategy_necessary_tip3: 'OTA automatic upgrade',
      strategy_necessary_tip4: 'Necessary app prompt',
      strategy_necessary_tip5: 'Does the device pop up a window to prompt the necessary apps',
      strategy_add_necessary: 'Add a Necessary app',
      strategy_safedesk_app: 'Safe Desktop App List',
      strategy_safedesk_tip: 'Safe Desktop',
      strategy_safedesk_tip2: 'Whether the device uses a safe desktop',
      strategy_add_safedesk: 'Add a safe desktop app',
      strategy_hideIcon_app: 'Hide icon app list',
      strategy_hideIcon_tip: 'Hide icon app tip',
      strategy_hideIcon_tip2: 'Does the device pop up a window to prompt the hidden icon app',
      strategy_add_hideIcon: 'Add a hidden icon app',
      strategy_fence_range: 'Fence Range',
      strategy_fence_switch: 'Fence Switch',
      strategy_device_limit: 'Device Limit',
      strategy_ssid: 'Service Set Identifier (SSID)',
      strategy_config_tip1: 'Wireless network ID to connect to',
      strategy_hidewifi: 'Hidden WiFi',
      strategy_config_tip2: 'When the target network is not development network or when there is no broadcast signal, please enable this function',
      strategy_config_autoIn: 'Automatically Join',
      strategy_config_tip3: 'Automatically join this wireless network',
      strategy_config_safeType: 'Safe Type',
      strategy_config_tip4: 'Wireless network encryption type used when connecting',
      strategy_config_password: 'Password',
      strategy_config_password_wifi: 'Wifi password',
      strategy_wifi_tip: 'Does the device pop up a window to prompt to disable the WIFI on blacklist',
      strategy_add_wifiblacklist: 'Add the WIFI on blacklist',
      strategy_wifi_enter: 'Please enter the WIFI name',
      strategy_voice_control: 'Device volume control',
      strategy_unEdit_default: 'Warning: the default strategy function limit is not editable! ',
      strategy_unEdit_unAuth: 'Warning: the strategy is outside the scope of your permission operation. The restriction function is not editable! ',

      strategy_set : 'Strategy settings',
      strategy_geo : 'Geographic location',
      strategy_call_time : 'Call time',
      strategy_operator : 'Operator information',
      strategy_app : 'Application',
      strategy_battery : 'Battery information',
      strategy_data_flow : 'Data flow',
      strategy_mobile_data : 'Mobile data',
      strategy_imei : 'IMEI',
      strategy_imsi : 'IMSI',
      strategy_memory: 'Memory usage',
      strategy_fence_set : 'Set fence range',
      strategy_fence_find : 'Find fence range',
      strategy_lng : 'Fence Longitude',
      strategy_lat : 'Fence Latitude',
      strategy_radius : 'Fence Radius',
      strategy_limit_device : 'Device',
      bluetooth : 'Bluetooth',
      restore_device_data:'Restore factory data regularly',

      camera : 'Camera',
      homekey : 'Home Key',
      stateBar : 'Pull Down Status Bar',
      strategy_app_config : 'App center attribute settings',
      strategy_app_password : 'Maintenance management password',
      strategy_app_request : 'Request frequency',
      strategy_time_minutes : 'Minutes',
      strategy_topic : 'Topic',
      strategy_common_area : 'Common area',
      strategy_common_function : 'Checkout area',
      strategy_show : 'Show',
      strategy_hide : 'Hide',
      strategy_add : 'Add strategy',
      strategy_delete_confirm : 'Strategy delete confirmation',
      strategy_delete_confirm1: 'Do you want to delete the strategy named as ({0})?',
      strategy_choose_confirm : 'Publish strategy confirmation',
      strategy_choose_confirm1 : 'Do you want to publish the strategy named as ({0})?',
      strategy_delete : 'Delete',
      strategy_choose: 'Apply strategy',
      strategy_copy : 'Copy',
      strategy_choosed : '(Applied)',
      strategy_no_data : 'No data',
      strategy_name : 'Strategy name',
      strategy_applied: 'Applied strategy',
      strategy_fence_scope : 'Fence scope',
      strategy_device: 'Device strategy',
      strategy_fence: 'Fence strategy',
      strategy_config: 'Configuration strategy',
      circle_inner: 'Disabled device within the fence',
      circle_outer: 'Disabled device outside the fence',
      circle_close: 'Close',
      circle_open: 'Open',
      fence_circle_set : 'Fence Circle Set',
      device_list : 'Device List',
      device_search: 'Search',
      device_moveto: 'Move to',
      device_add : 'Add a Device',
      dev_add: 'Device Add',
      dev_edit: 'Device Edit',
      device_batch_delete : 'Delete in Batches',
      device_batch_delete_confirm : 'Delete Confirmation',
      device_batch_delete_confirm_tip : 'Are you sure to delete these devices? Continue or not? ',
      device_template_download : 'Template Download',
      device_import : 'Import in Batches',
      device_imp: 'Import Devices',
      device_download_import: 'Download Import Template',
      device_moreoper: 'More Operations',
      device_log : 'Device Uploads the Diagnostic Log',
      device_upload_pp_log : 'Device uploads the application log',
      device_log_refresh : 'Refresh List',
      device_log_time : 'Log Time',
      download : 'Download',
      app_id : 'App ID',
      device_warn_type : 'Warning Type',
      device_warn_level : 'Warning Level',
      device_code : 'Device Code',
      device_type : 'Device Type',
      device_belong_company: 'Belong to Which Company',
      device_map_change: 'Switch',
      device_number_type: 'Current Number of Devices:',
      device_holder : 'Holder',
      device_login_user : 'User',
      device_fence_status : 'Fence Status',
      device_fence_closed : 'Closed',
      device_fence_opened : 'Opened',
      device_warn_status : 'Warning Status',
      device_warn_warn : 'Warning',
      device_warn_normal : 'Normal',
      device_status : 'Device Status',
      device_active_strategy: 'Applied Strategy',
      device_active_status: 'Active State',
      device_activation_status: 'Activation State',
      device_active_online: 'Online',
      device_active_offline: 'Offline',
      device_activation_yes: 'Activate',
      device_activation_no: 'Not activated',
      device_status_unknown: 'Unknown',
      device_status_normal : 'Normal',
      device_status_warn : 'Warning',
      device_status_forbidden : 'Disabled',
      device_order_forbidden: 'Freeze the Device',

      device_status_locked : 'Lock screen',
      device_template : 'Device information import template',
      app_coverage_upgade1 : 'After coverage upgrade, the previous version (',
      app_coverage_upgade2 : ') will be replaced, are you sure to override this grayscale version? ',
      app_to_edition1 : 'After converted to the official version, the previous grayscale version (',
      app_to_edition2 : ') will be replaced, are you sure to convert this grayscale version to the official version? ',
      app_normal_upgrade1 : 'After coverage upgrade, the previous official version (',
      app_normal_upgrade2 : ') will be replaced, are you sure to overwrite this official version? ',
      device_lock_tip : 'This operation will lock the screen of this device. Continue or not?',
      device_forbidden_tip : 'This operation will disable the device. Continue or not?',
      device_unforbidden_tip : 'This operation will make the device available. Continue or not?',
      device_restart_tip : 'This operation will restart the device. Continue or not?',
      device_closeFence_tip : 'This action will close the fence. Continue or not?',
      device_openFence_tip : 'This operation will open the fence. Continue or not?',
      device_shutdown_tip : 'This operation will shut down the device. Continue or not?',
      device_ring_tip: 'The device will ring with the maximum ringtone, and the device can only be turned off by restarting',
      device_extract_dvc_logs_tip : 'This operation will extract the device log. Continue or not? ',
      device_restore_tip: 'This operation will restore the device to factory settings. Continue or not?',
      device_delete_tip : 'This will remove all information about the device. Continue to delete or not?',
      device_clear_tip : 'This operation will clear the data of this device. Continue or not?',
      device_disabled_tip: 'This operation will disable the device, message you type in the following textarea will display on the screen. Continue or not?',
      device_disabled_msg:'Hello, this is my lost device, which has very important information for me. I hope you can contact me after you see the message. Thank you very much.\n' +
        'my contact information: ',
      device_available_tip: 'This operation will make the device available. Continue or not?',
      app_config_tip : 'This operation will delete the application\'s configuration file. Continue or not?',
      device_imei : 'IMEI',
      device_sim : 'SIM',
      device_description : 'Device description',
      device_address : 'Device address',
      device_fnsn : 'FNSN',
      device_type_tip : 'Please select a device type',
      device_detail : 'Device details',
      device_operator : 'Operator',
      device_call_time : 'Call time',
      device_sign : 'Device signature',

      device_version : 'System version',
      Android_version: 'Android version',
      device_appcenter_version : 'App version',
      devcice_os_version: 'OS version',
      device_collect_time : 'Collect time',
      device_battery : 'Battery',
      device_current_battery : 'Current battery',
      device_geo : 'Location',
      device_current_geo : 'Current location',
      device_warn_detail : 'Warn details',
      device_app : 'Device app',
      device_instruction : 'Instruction management',
      device_instruction_edit : 'Edit',
      device_instruction_lock : 'Screen lock',
      device_instruction_forbidden : 'Forbidden',
      device_instruction_enable : 'Enable',
      device_instruction_delete : 'Device deletion',
      device_delete_temp_again:' Warning: Delete the device or not? ',
      device_instruction_unforbidden : 'Unforbidden',
      device_order_unforbidden : 'Device Unforbidden',
      device_instruction_unlock : 'Screen Unlock',
      device_order_unlock: 'Unlock The Screen',
      device_order_restart: 'Restart Device',
      device_order_shutdown: 'Shutdown Device',
      device_order_restored: 'Device is restored to factory',
      device_instruction_clear : 'Clear Data',
      device_instruction_log : 'Device Log',
      device_instruction_app_log: 'Application Log',
      device_instruction_open_fence : 'Open Fence',
      device_instruction_close_fence : 'Close Fence',
      device_instruction_history : 'History Instruction',
      device_instruction_manager : 'Current Management Device',
      device_instruction_time : 'Log Time',
      device_instruction_type : 'Instruction Type',
      device_status_unlock : 'Unlock',
      device_status_unforbidden : 'Unforbidden',
      device_locate : 'Locate',
      device_app_log : 'Application Log',
      device_diagnosis : 'Diagnostic Log',
      device_delete : 'Delete',
      device_clear_data : 'Clear Data',
      device_fence_open : 'Open Fence',
      device_fence_close : 'Close Fence',
      device_path_applog : 'Specify the path application log',
      device_instruction_unknow : 'Unknown',
      device_instruction_status : 'Instruction Status',
      device_instruction_status_sended : 'Sent',
      device_instruction_status_performed : 'Already Performed',
      device_instruction_sender : 'Sender',
      device_instruction_send_time : 'Send Time',
      device_geo_success : 'The positioning instruction was sent successfully',
      device_function_disable_list : 'Function disabled list',
      device_function_recovery : 'Restore All Functions',
      device_function_disable : 'The device will terminate the checked service. Continue or not?',
      device_function_recovery_all : 'This operation will restore all functions of the device. Continue or not?',
      device_import_tip : 'If the imported file data overlaps with the original data, please select the processing method',
      device_import_original_data : 'The original data prevails',
      device_import_file_data : 'The data in the file (default) prevails',
      device_import_btn : 'Click to select the file to import',
      device_lock_pwd : 'Lock screen password',
      device_management : 'Management',
      device_voice_jy : 'Device Mute',
      device_voice_jzjy : 'Mute Disabled Devices',
      device_voice_max : 'Maximize Device Sound',

      device_del_app: 'Delete App',
      device_sys_log: 'System Log',
      device_error_log: 'Error Log',
      device_log_TUSN: 'SN',
      device_log_type: 'Getting Method',
      devcei_log_operating: 'Operation',
      device_updata_sys_log: 'Upload Log',
      device_log_refresh_b: 'Refresh',
      device_deleteapp_tip: 'This operation will uninstall the app on the device. Continue or not?',

      device_basic : 'Basic Information',
      device_app_info : 'Application Information',
      device_sd_control : 'SD Card Control',
      device_log_info : 'Log Information',
      device_phone_info : 'Phone Information',
      device_message_record : 'Message Record',
      device_location_info : 'Location',
      device_warn_info : 'Warning Information',
      device_wifi_dosage : 'WiFi Usage',
      device_storage_capacity : 'Storage cCpacity',
      device_data_throughput_dosage : 'Data Throughput Dosage',
      device_communication_records : 'Call Record',
      device_device_contacts : 'Device Contact',
      device_message_type : 'Message Type',
      device_message_number : 'Message Number',
      device_message_contacts : 'Contacts',
      device_message_date : 'Message time',
      device_communication_type : 'Communication Type',
      device_communication_number : 'Communication Number',
      device_communication_time : 'Communication Time',
      device_phone_number : 'Phone Number',
      device_call_in : 'Call In',
      device_call_out : 'Call Out',
      third_app_select_app : 'Please select an app',
      third_app_select_device : 'Please select a device',
      third_app_config_upload : 'Configuration file upload (subject to the last upload)',
      click_upload : 'Click Upload (file format: txt)',
      click_upload_xls : 'Click Upload (file format: xls)',
      fetch_device_log : 'Fetch the Device Log',
      tms_upload : 'TMS Upload',
      tms_name : 'Name',
      tms_package_name : 'Package Name',
      tms_size : 'Size',
      tms_version_name : 'Version Name',
      tms_version_code : 'Version Code',
      tms_create_user : 'User',
      tms_remark : 'Remark',
      tms_create_time : 'Create Time',
      tms_upload_tip : 'Drop files here or click here',
      tms_logo : 'Logo',
      app_center_delete_tip : 'This operation will delete the app center on the device. Continue or not?',
      device_directory_upload : 'Specify directory to upload',
      directory_upload_tip : 'Please enter the specified directory',
      app_log_flag : 'Getting Method',
      app_get_directly : 'Directly',
      app_get_directory : 'Directory',
      app_directory : 'Specify Directory',
      config_download : 'Configuration download',
      editApp : 'Edit App',
      select_organization : 'Select an Organization',
      click_select : 'Click to Assign',

      organization_allot: 'Allot Organization',
      telephone_add: 'Add a Telephone',
      telephone: 'Telephone',

      save : 'Save',
      updateInfo: 'Update Information',

      btnadd: 'Add',
      btnupdate:'Update',

      inputsn: 'Input SN Number',
      snexport : 'Import in Batches',
      sn_temp_down : 'Download Template',
      uploadWaiting: 'Please wait. The data is being uploaded and processed',

      snno: 'No.',
      snnum: 'sn',
      devType: 'Device Type',
      sn: 'SN Number',
      add_remark: 'Add a Remark',
      edit_remark: 'Edit a Remark',
      sure: 'Sure',
      remark_tips: 'Please enter no more than 200 characters',
      orgName: 'Organization Name',
      snstatus: 'Status',
      snstatus_normal: 'Normal',
      snstatus_non_existent: 'Does not exist',
      snstatus_sn_repeat: 'SN Repeat',
      snstatus_sn_published: 'Published SN Repeat',
      snstatus_sn_notcontain: 'Device Type Mismatch',
      onemorevertips: 'Tip: {0}, {1} apps have multiple versions, and the highest version is released by default.',
      addBanner: 'Add a Banner',
      link: 'Link',
      editBanner: 'Edit Banners',
      selectAll: 'Select All',
      search_app_name: 'Search Apps Name',
      autoOnShelf: 'Automatic Apps Upload',
      handOnShelf: 'Manual Apps Upload',
      uploadedApp: 'Loaded Apps',
      unuploadedApp: 'Not Loaded Apps',
      detail: 'Details',
      export:'Export',
      device_se_version:'SE version',
      app_currently_installed: 'Currently Installed App',
      app_install_num_zero: 'The currently installed app is 0',
      activation_time: 'Activation Time',
      last_active_time: 'Last Active Time',
      myDevice_fileName: 'My Machine',
      app_param_error_fileName:'Error parameter configuration',
      device_app_fileName: 'Device Application',
      app_delete_tip:'Are you sure to delete the apk?',
      app:'application',
      app_del_tip:' will be removed ，but the installed apps on the terminal will not.',
      app_delete_tip0:'Please Notice : Application',
      app_delete_tip1_version:'version',

      version:'version',
      deviceLifeCycle:{

        filename: 'Device Life Cycle',
        shipedEquipment: 'Shipped Devices (set)',
        cumulativeActivatedEquipment: 'Accumulative Activated Devices (set)',
        deviceDataOverview: 'Device Data Overview',
        shipDate: 'Shipment Date',
        activationDate: 'Activation Date',
        search_sn_tip: 'Enter SN',
        search_deviceTytp_tip: 'Device Type Selection',
        queryBtn: 'Query',
        export: 'Export',
        collectDateBegin: 'Begin Date',
        collectDateEnd: 'End Date',
        SN: 'SN Number',
        deviceType: 'Device Type',
        shipTime: 'Shipment Date',
        activationTime: 'Activation Time'
      },
      inter_sn_query: 'Enter SN',
      device_type_choose: 'Device Type',
      online_status_choose: 'Status',
      apply_install: 'Install Apps',
      three_apply_install: 'Install Third-party Apps',
      usb_debug: 'USB Debugging',
      power_flow_config: 'Power & Data Management',
      high_precision_model: 'High-accuracy Mode',
      balance_model: 'Balance Mode',
      energy_conservation_model: 'Power Saving Mode',
      custom_model: 'Custom Mode',
      high_precision_model_detail: 'The map uses high-accuracy mode,with push,the polling time is 10minutes, power cache frequency is 1 minute.',
      balance_model_detail: 'The map uses balance mode,with push,the polling time is 3 hours, power cache frequency is 10 minute.',
      energy_conservation_model_detail: 'The map uses power saving mode,with push,the polling time is 24 hours, power cache frequency is 60 minute.',
      push_setting: 'Push Notification:',
      using: 'Yes',
      onUsing: 'No',
      map_setting: 'Map Mode: ',
      preciseness: 'High Accuranacy',
      energy_conservation: 'Power Saving',
      polling_time_setting: 'Polling Time:',
      power_cache_frequency_setting:'Power Cache Frequency:',
      minute: 'Minutes',
      custom_start: 'Save',
      start_success: 'Start Successfully',
      time_input: 'You can only enter an integer for Polling Time, not exceeding 24 hours (or 1440 minutes)',
      deviceType_searchTip:'Please select a type',
      shelfList_searchTip:'app name/device group name',
      shelfList_searchTip1:'app name',
      device_export_rule:'Please download this template and use this template for terminal deployment.',
      inputSnOrRemark:'Enter sn or remarks',
      inputSearchAddress:'Enter address of devices',
      messagePush:'Push Message',
      bootLogo:'Boot Logo',
      enterMessage:'please enter push message',
    },
    bootAni:{
      dvcTypeSelect: 'Model Selection:',
      boot_Ani_Method_select: 'Select Animation:',
      boot_ani_method_default: 'Default',
      boot_ani_method_customize: 'Customize',
      select_zip: 'Select ZIP Package',
      zip_rule: 'Rules',
      download_boot_temp: 'Download Template',
      boot_load_ing: 'The boot animation preview file is being generated. Please be patient. ',
      boot_join_ing: 'Loading...',
      cur_no_boot: 'Currently no animation',
      choice_boot: 'Click the button of \'Select ZIP Pack\' to create a customized boot animation. ',
      play_speed: 'Play Rate:',
      second:'/Second',
      apply_boot: 'Apply to Device Selected',
      zip_parse_fail: 'ZIP Parse Failed',
      zip_parse_fail_desc: 'ZIP parse failed. Please refer to the template and ZIP production rules for details. ',
      select_true: 'OK',
    },
    error: {
      boot_ani_type_error: 'The format of the boot animation file is ZIP',
      boot_ani_max_file: 'The compressed file of boot animation supports up to 20M',
      packagename_exist: 'The application package name already exists. Please do not add it repeatedly',
      app_blank_necessary_conflict: 'The app on the blacklist and the necessary app can\'t be the same',
      safedesk_hideapp_conflict: 'Safe desktop app and hidden app can\'t have the same icon',
      wifi_exist: 'This wifi already exists. Please do not add it repeatedly',
      wifiblank_ssid_conflict: 'wifi blacklist settings conflict with wifi remote settings',

      sn_is_not_empty: 'The device number cannot be empty',
      ssid_exist_blanklist: 'ssid conflicts with wifi blacklist',
      strategy_data_safeType: 'Please select a safe type',
      tel_space_rule: 'Telephone cannot be empty',
      packagename_rule: 'Package name and application name cannot be empty',
      packagename_rule2: 'Please enter the correct package name',
      wifiname_rule: 'WIFI name cannot be empty',
      select : 'Please select',
      param_error : 'The parameter is incorrect',
      username_rule : 'Account does not match the rule',

      username_rule_1 : 'The account only includes [letters, numbers, underline, -] and must start with a letter, with the length of 5-20',
      password_more_6 : 'The password cannot be less than 6 digits',
      password_less_20 : 'The password cannot be greater than 20 digits',
      password_rule_1 : 'Passwords should have no less than 6 digits,with capital letters and numbers.',
      verifycode_eq_4 : 'Verification code is 4 digits',
      verifycode_empty: 'Please enter the verification code',
      email_rule : 'Please enter the correct email address',
      sub_account_name_tip: 'Please enter the sub-account name',
      tel_rule : 'Please enter the correct mobile number',
      tel_rule2: 'Please enter the correct phone number',
      nickname_rule : 'User name only includes letters, numbers and Chinese. The length is 1-10. Please enter the correct username',
      dvcGroup_rule: 'The device group name only includes [Chinese characters, letters, number, -], and the length is 1-10.',
      selectsex : 'Please select the gender',
      selectrole : 'Please select a role',
      selectmanuauth : 'Please select menu authority',
      selectuser : 'Please select a user',
      job_rule : 'Length is 0 to 50 characters',
      description_rule : 'Length is 0 to 100 characters',
      password_rule : 'Length is 6 to 20 characters',
      avatar_rule : 'The size of the avatar must not exceed 500KB',
      avatar_format_rule : 'Only upload files in format of jpg, jpeg',
      apk_format_rule : 'Only upload files in format of apk',
      apk_size_rule : 'apk file cannot be larger than 300MB',
      password_inconsistency : 'Two input passwords are inconsistent',
      password_old : 'Please enter the original password',
      password_new_more : 'Please enter the new password again',
      password_length : 'Length is 8 to 20 characters',
      organizationid_rule : 'Only include [letters, numbers]. The length is 1-20 characters',
      organizationname_rule : 'Only include [Chinese characters, letters, numbers, spaces, @, _, -,.], and the length is 1 to 30 characters',
      organizationias_rule : 'Only include [Chinese characters, letters, numbers, spaces, .], and the length is 0 to 10 characters',
      organizationprincipal_rule : 'Only include [Chinese characters, letters, numbers], l and the length is 0 to 10 characters',
      organizationdescription_rule : 'Only include [Chinese characters, letters, numbers], and the length is 0 to 200 characters',
      organizationaddress_rule: 'Only include [Chinese characters, letters, numbers], and the length is 1 to 100 characters',
      appname_rule : 'Length is 1 to 30 characters',
      appfeature_rule : 'Length is 0 to 200 characters',
      appproducer_rule : 'Length is 0 to 50 characters',
      bussType_rule : 'Business type cannot be empty',
      devtype_rule: 'Device type cannot be empty',
      devtype_rule2:' ',
      appdesc_rule : 'Length is 0 to 100 characters',
      updatebrowser : 'Please update the browser',
      content_rule : 'The message content cannot be empty',
      title_rule : 'The message title cannot be empty',
      strategy_name_rule : 'The strategy name is 1 to 15 digits and consists of Chinese characters, English, -,',
      device_code_rule : 'SN can be up to 30 characters, and you can enter letters and numbers',
      device_imei_rule : 'IMEI number can be up to 20 characters, and you can enter letters and numbers',
      device_sim_rule : 'Please enter the legal SIM card number',
      device_description_rule : '100 characters at maximum',
      device_import_rule : 'Only files in format of xls  can be imported',
      device_import_size_rule : 'The imported file must not exceed 5MB',
      file_send_size_rule : 'The import file must not exceed 100MB',
      third_config_rule : 'Only files in format of txt can be uploaded',
      third_app_size_rule : 'txt file cannot be greater than 10KB',
      password_confirm_error : 'Password Error',

      simplePassword:'password is too simple to ensure enterprise security,please reset',
      numberLetterRepeatFiveTimes:'Do not include more than 5 duplicate Numbers or letters',
      fiveContinuousNumber:'Do not include more than 5 continuous Numbers',
      atLeastSixContainLetterNumber:'Passwords should have no less than 6 digits,with letters and numbers',



      job_rule_1: 'Job only includes [Chinese characters, letters, numbers, -], and the length is 0-50',
      nickname_rule_1 : 'Name only includes [Chinese characters, letters, numbers, underline, -], and the length is 1-10',
      email_rule_1 : 'Email only includes English letters, numbers, underline, periods, @, and strikethrough',
      description_rule_1: 'Description only includes [Chinese characters, letters, number, comma, period], and the length is 0-100',

      organizationaddress_rule_1: 'Organization address only includes [Chinese characters, letters, numbers], and the length is 0 to 100 characters',
      organizationname_rule_1 : 'Organization name contains only [Chinese characters, letters, numbers, spaces], and the length is 1 to 30 characters',
      organizationias_rule_1: 'Organization abbreviation only includes [Chinese characters, letters, numbers, spaces], and the length is 0 to 10 characters',
      organizationprincipal_rule_1 : 'Organization contact person only includes [Chinese characters, letters, numbers], and the length is 1 to 20 characters',
      organizationdescription_rule_1 : 'Organization description only includes [Chinese characters, letters, numbers], and the length is 0 to 200 characters',

      currentorganizationlogotips: 'This logo is the organization to which the current account belongs',

      strategy_name_rule_1: '15 words at maximum',
      strategy_name_exist: 'The name already exists. Please re-enter the strategy name',
      strategy_data_not_exist: 'No data currently',
      strategy_select_not_one: 'Please select a piece of data',
      device_import_data_error : 'The data you imported contains illegal data. The legal data has been imported for you, and a report on error data has been generated for you! ',

      sn_import_size_rule : 'The import file must not exceed 5MB',
      sn_import_rule : 'Only files in format of xls  can be imported',
      sn_import_error: 'File import exception. Please contact the administrator!',
      sn_import_model_error: 'Imported device is empty or imported template is in error. Please check the template',
      cannot_pub_by_sn: 'The current version cannot be published by greyscale!',

      sn_import_count: 'Number Imported',
      sn_import_error_count: 'Number Failed',
      sn_import_success_count: 'Number Succeeded',

      image_format_rule: 'Image type is not supported',
      package_conflict: 'The package names are inconsistent. Please re-upload',
    },
    tip : {
      select_sn_unbind:'Please select device',
      boot_ani_effective_success: 'Boot animation is in effect successfully',
      boot_ani_save_success: 'Boot animation saved successfully',
      boot_ani_parse_success : 'Boot animation parsed successfully',
      uploadbanner: 'Please upload an image',
      repeatClick: 'Do not click repeatedly',
      operation_success : 'Operation Succeeded',
      ring_pwd : 'Password must be 4 digital number',
      wait_a_minute : 'Please wait a minute',
      operation_fail : 'Operation Failed',
      device_group_select:'Please select a device group',
      device_group_add_device_down:'Device groups cannot be added under ungrouped devices',
      device_group_delete_device_down:'Ungrouped devices cannot be deleted',
      device_group_edit_device_down:'Ungrouped devices cannot be edited',
      device_fence_circlePath_tip: 'The fence range cannot be empty and must be a number',
      device_fence_cricle_center_lng: 'The longitude of the fence center must be a number valued between -180 and 180',
      device_fence_cricle_center_lat: 'The latitude of the fence center must be a number valued between -90 and 90',
      device_fence_cricle_center_radius: 'The fence radius must be a number valued must more than 0',
      device_fence_circle_center_param_error:'Device fence parameter error',
      device_fence_circle_frequency_param_error:'Frequency can only be passive integer',
      device_fence_circle_name_param_error:'Rule name can not empty',
      device_fence_circle_mail_error:'Email format error',
      strategy_data_send_tip : 'Please select the information uploaded by the device',
      strategy_data_fence_tip : 'Please set fence information',
      node_change_tip : 'Please select the node that needs to change',
      loading_wait_tip: 'Loading. Please wait a moment',
      uploading: 'Uploading...',
      del_app_command_success : 'Deletion command has been sent',
      selectappversion: 'Please select the application version (required)',
      selectpublishtype: 'Please select the publishing method (required)',
      publishtypebynormal : 'Normal publish',
      publishtypebysn : 'SN publish',
      selectgnodes: 'Please select the visible range (required)',
      shelfAppWhenCreateOrgs : 'Newly published organization is automatically synced to this app',
      appversiontips: 'Version Tip',
      banner_tip: 'Image Size: 672*290px;Format: jpg/png;Maximum Size:500K;Maximum Quantity:Five',
      uploadSpecification: 'Banner Format',
      appDescPicSize : 'The image size must not exceed 5M!',
      appBannerPicSize: 'The image size must not exceed 500K!',
      appDescFormatter : 'Please upload the image in the correct format',
      bootLogoDescFormatter : 'Please upload an image in jpg/png/gif format',
      bootLogoAvatarSize : 'The image size must not exceed 10Mb!',
      appDescUploadError : 'Image upload error!',
      appAvatarSize : 'The image size must not exceed 100K!',
      appAvatarNotNull : 'The app icon does not exist',
      appDescNotNull : 'Please upload an app description image',
      appNameNotNull : 'Please enter the app name!',
      appDevTypeNotNull : 'Please check the device type!',
      addBannerTip: 'Upload Images (png/jpg within 672*290 and 500K): ',
      confirmBannerDelete: 'Are you sure to delete this ad? ',
      app_version_manage_tip1 : 'Upgrade feature description',
      app_version_manage_tip2 : '1. Grayscale upgrade: The new version is only available in a limited specified range. Other machines continue to use the fully deployed official version and are applicable to the use of a new version in a small range; ',
      app_version_manage_tip3 : '2. Coverage upgrade: The uploaded grayscale version is replaced with the latest version, which is applicable to the last grayscale version with BUG. The last grayscale version will be removed; ',
      app_version_manage_tip4 : '3.Normal upgrade: No grayscale upgrade is required. Normal upgrade is directly performed. All machines will use the new version, and the old version will automatically be removed; ',
      app_version_manage_tip5 : '4. Convert to the official version: The grayscale range is required to be all. The previous official version will be replaced, and the old version will be automatically removed; ',
      app_version_manage_tip6 : '5. Increase the grayscale range: Increase the deployment range above the original grayscale range. No problems are found when applied in a small scale. The trail range is expanded to confirm whether it is valid; ',
      app_unreview_tip : 'The review takes about 1 business day. Please be patient. (This account\'s device is already available for apps at this version, and there is no need to review.)',
      handPut: 'Are you sure to switch to manual put mode? ',
      autoPut: 'Are you sure to switch to automatic put mode? (The unpublished apps will be automatically put on shelf)',
      remoteDevice_details_fail : 'This device has not yet uploaded details',
      remoteGroup_search_null : 'This group is not found',
      silentApp_tip: 'For each model you can select one APP that will automatically start when the device is powered on',
      no_silentApp_tip: '',
      confirmSilentAppDelete: 'This operation will remove the default start APP . Continue or not?',
      numberGreaterThanZero:'The number has to be greater than 0',
      fileTypeNotSupport:'File types are not supported',
      mustApk:'The file type is incorrect, please upload the APK file',
      cus_max_size:'Maximum upload 100M file',
      user_permissions_not:'The user does not have the relevant operation authority',
    },
    login: {

      title : 'Business terminal management platform',
      username: 'Username',
      usernametip : 'Account/Mail',
      password : 'Password',
      authedicate : 'Verification code',
      loginbtn : 'Login',
      register_btn: 'Sign Up',
      platformName:'Partner Connect',
      verifycode:'Verification Code',
      rememberMe:'Remember Me',
      login_check_company_input: 'Please click on the page of Business information management - Company information to fill in company information',
    },
    register:{
      register_mailbox: 'Register Mailbox',
      set_password: 'Set the Password',
      partner: 'Cooperative platform partner',
      verify_identidy: 'Verify Identification',
      account: 'Account',
      active_success: 'Activation Succeeded',
      active_fail: 'Activate link has expired',

      email_tip: 'Please enter your email address',
      user_name_tip: 'Please enter a username',
      password_tip: 'Please enter a password',
      password_again: 'Confirm the Password',
      password_again_tip: 'Please confirm the password',
      verify_code: 'Please enter the code',
      register_now: 'Register Now',
      forget_password: 'Forget the password?',
      register_email_send_tip1: 'The activation email has been sent to your registered email address',
      register_email_send_tip2: 'Please, within 24 hours',
      register_email_send_tip3: 'Click on the link inside the email to complete the registration',
      register_email_check: 'Check your email immediately',
      agree_service_items: 'Agree to the Terms of Service',
      no_email_received: 'No Email Received',
      resend_email: 'Resend Email',

      register_email_no_send: 'No Mail Received',
      register_email_again_send: 'Resend Mail',
      next_step: 'Next Step',


    },

    reset:{
      register_password: 'Reset the Password',
      email_reset_password: 'Email Reset',
      tel_reset_password: 'Telephone Number Reset',
      email_check_reset_password: 'Email Verification',
      button_content_step1: 'Send Verification Code',
      again_send_code: 'Resend Verification Code',
      resend_code_again_after: 'Resend After',
      next_step: 'Next Step',
      email_reset: 'Reset Mailbox',
    },
    companyinfo:{
      copy: 'Copy',
      company: 'Company',
      select_country: 'Please select your country/region',
      company_name_rule: 'Please enter the company name',
      company_address_rule: 'Please enter the company address',
      company_website_rule: 'Please enter the correct website',
      company_area_rule: 'Please enter the area where the company is located',
      company_credential_rule: 'Please upload the business license or ID card',
      company_review_tip: 'The review takes about one business day. Please be patient',
      image_format_rule: 'Image type is not supported',
      image_size_rule: 'The maximum picture size is 5M',
      company_image_upload_error: 'Document image upload failed',
    },

    groupManage:{
      add:"add",
      group_name:"Group Name",
      address_info:"location information",
      admin_name:"Administrator Name",
      contact_information:"Contact information",
      remarks:"Remarks",
      import_group:"Import Groups",
      clear_group_data:"Empty Existing Groups",
      import_temp_download:"Download Template",
      error_group_download:"Download",
    },

    remoteConfig:{
      min_port: 'The port is a number, the first digit should be greater than 0 and the length is 2-10 digits',
      min_mms_port: 'MMS port is a number, the first digit should be greater than 0 and the length is 2-10 digits',
      port_mix: 'Please enter 2-10 digits',
      apn_setting:'APN Settings',
      wifi_setting:'WIFI Settings',
      function_control:'Function Settings',
      ssid:'SSID',
      wifi_whitelist_setting:'WIFI Whitelist Settings',
      name:'Name',
      type:'Type',
      pus_range:'Push Range',
      status:'Status',
      execution_progress:'Execution Progress',
      operate:'Action',


      config_name_not_empty:'Rule name cannot be empty',
      apn_not_empty:'APN cannot be empty',
      apn_name_not_empty:'APN name cannot be empty',
      mcc_not_empty:'MCC cannot be empty',
      mnc_not_empty:'MNC cannot be empty',
      select_push_range:'Select push range',
      config_name:'Config Name',
      my_config_name:'My APN Configuration',
      apn_name:'APN Name',
      apn:'APN',
      agent:'Agent',
      port:'Port',
      user_name:'Account',
      password:'Password',
      server:'server',
      mmsc:'MMSC',
      mms_agent:'Mms Agent',
      mms_port:'Mms Port',
      mcc:'MCC',
      mnc:'MNC',
      authentication_type:'Authentication Type',
      apn_type:'APN Type',
      apn_protocol:'APN Protocol',
      empty_null:'none',
      apn_protocpl_name:'PAP/CHAP',
      config_name_not_null:'Config Name Can Not Empty',
      apn_not_null:'APN Can Not Empty',



      wifi_name:'Name',
      wifi_name_tip:'Please enter a wifi name',

      not_push:'Unpushed',
      already_push:'Pushed',
      qr_code_generate_tip:'Please fill in the setting information before generating the QR code',
      qr_code_generate:'QR Code',
      qr_code_generate_new_tip:'Click to generate a WIFI connection QR code. The device can scan the QR code to connect to the corresponding network.',
      wifi_setting_push:'WIFI Settings Push',
      config_push:'Push',
      config_edit:'Edit',

      delete_apn_config_batch:'Delete APN Configuration',
      delete_apn_config_batch_tip:'Delete the APN configuration, and the configuration information on the device side is also deleted. The device restores the original settings. Is it deleted?',


      delete_wifi_config_batch:'Delete WIFI Configuration',
      delete_wifi_config_batch_tip:'Delete the WIFI configuration, and the configuration information on the device side is also deleted. The device restores the original settings. Is it deleted？',
      yes:'yes',
      no:'no',

      add_wifi_whitelist:'WIFI Whitelist Added',
      whitelist_ssid:'Network Name (SSID)',

      whitelist_ssid_tip1:'After pushing the whitelist, the device can only connect to the WIFI of the whitelist',
      whitelist_ssid_tip2:'(The SSID in WiFi settings is added to the whitelist by default);',
      whitelist_ssid_tip3:'If you do not push the whitelist, WiFi connection is not restricted.',
      whitelist_ssid_tip0:'Please enter the SSID of the whitelist. Separate them with commas, for example: WIFI11, WIFI22, WIFI33',

      delete_wifi_whitelist_config_batch:'Delete WIFI whitelist configuration',
      update_wifi_whitelist_no_ssid_delete:'This operation deletes all the whitelist WIFI in the whitelist rule, and the whitelist rule will also be deleted synchronously.',
      delete_wifi_whitelist_config_batch_tip1:'If you delete the WIFI whitelist configuration,',
      delete_wifi_whitelist_config_batch_tip:'the configuration information on the device will also be deleted. The device will restore the original settings. Do you want to delete it?',
      wifi_whitelist_config_edit_tip:'WIFI whitelist setting modification',
      wifi_whitelist_config_history_push:'Wifi whitelist history push content',
      wifi_whitelist_config_push:'WIFI whitelist push',

      push_wifi_whitelist_config_batch_tip:'Push WIFI whitelist configuration, whether to push?',

      enterPositiveInt:'please enter positive integer',

      wifi_whitelist_select_group_error:'Please select a device group',

      wifi_whitelist_ssid:'Whitelist Network Names',
      wifi_whitelist_group_wifi_ssid:'SSID in WIFI configuration in group',
      wifi_whitelist_group_wifi_ssid_new:'Add Manully',


      wifi_whitelist_group_ssid_list:'SSID in WIFI configuration',

      wifi_whitelist_look_more:'See More',

      wifi_whitelist_name_default:'My WIFI whitelist',

      wifi_whitelist_name_is_exists:'Please enter a rule name',

      wifi_whitelist_push_range_is_exists:'Please select push range',

      wifi_whitelist_ssid_name_is_exists:'Please add whitelist wifi network name',

      wifi_whitelist_ssid_empty:'No information',

    },

    customDesk:{
      name : 'Name',
      pushGroups : 'Push Range',
      dvcType: 'Device Type',
      packageName : 'Package Name',
      unlockPwd : 'Unlock Password',
      hideStatusBar : 'Hide Status Bar',
      hideNavigationBar: 'Hide Navigation Bar',
      timedUnlock: 'Timed Unlock',
      lockTime: 'Lock Screen Duration',
      template: 'Template',
      layout:'Icon Layout',
      row: 'Row',
      column: 'Column',
      templateFile: 'Template File',
      pic: 'Background Pictures (file format supports jpg、jpeg、png, up to 30M pictures)',
      empty_custom_desk_tip:'Please fill in custom desktop name',
      rule_name:'Rule Name',
      cus_desk_set:'Custom Desktop',
      del_desk_tip:'Remove Custom Desktop',
      del_desk_tip1:'If you delete a customized desktop, the configuration information on the device side is also deleted. The device returns to the Android default desktop. Do you want to delete it?',
      cus_desk_push:'Custom Desktop Push',
      edit_desk:'Edit Custom Desktop',
      operate_record_detail:'Operation Record Details',
      select_rang:'Select Range',
      hour:'Hour',
      stand_template:'Standard Template',
      customize:'Customize',
      custom_template_file:'Custom Template File(please upload the apk format file to support a maximum of 100M)',
      submit:'Submit',
      yes:'Close',
      download_config:'Download The Configured File',
      lockTimeRule:'Lock Time should be 1-48',
      rowRule:'Row should be 1-4',
      colRule:'Column should be 2-5',
      default_cus_name:'My Custom Desktop Rules',
    },

    statistic: {
      user_statistic : 'Number of Users',
      device_statistic : 'Number of Devices',
      device_status_statistic : 'Device Status',
      device_operator_statistic : 'Operator',
      device_system_statistic : 'Operating System',
      show : 'Show',
      hide : 'Hide',
      device_status : 'Device Status Proportion',
      device_operator : 'Operator Distribution',
      operator_detail : 'Details',
      device_status_detail : 'Device Details',
      system_version_distribution: 'Android System Version',
      oSVersion_distribution: 'OS Version Information',
      apps_installation : 'App Installation Details',
      apps_installed : 'Installed',
      apps_name : 'App name',
      apps_device : 'Number of devices'
    },
    dashboard : {
      users : 'Number of Users',
      devices : 'Number of Devices'
    },
    account: {
      date : 'Last Update Time',
      childName : 'Sub-account Name',
      childShortName : 'Sub-account Abbreviation',
      contacts : 'Contact',
      type : 'Type',
      status : 'Status',
      appMarketConfig : 'App Market Configuration',
      operate: 'Operate',
      search_tip: 'Enter Name or Email to Search',
      search_tip2: 'Enter the Business Name or Abbreviation',
      cooperative: 'Independent',
      control: 'Control',
      review_yes: 'Normal',
      review_no: ' Review Failed',
      review_wait: 'Review Pending',
      wait_register: 'Invited, wait to register',
      appMarket_free: 'Completely independent and free application market',
      appMarket_clone: 'Clone the Apps of the parent account',
      appMarket_choose: 'Select from the App market of the parent account',
      appMarket_parent: 'The parent account sets the apps on shelf for the sub-account',
      account_child_name_tip: 'Please enter the name of the sub-account',
      account_child_short_name_tip: 'Please enter the short name of the sub-account',
      account_child_short_namr_error_tip: ' Only include [Chinese characters, letters, numbers, spaces]. The length is 0 to 10 characters',
      account_child_principal_tip: 'Please enter the contact of the sub-account',
      account_child_email_tip: 'Please enter the mailbox’ of the sub-account\’s administrator',
      add_control_account: 'Add a Controlled Sub-account',
      add_cooperative_account: 'Add an Independent Sub-account',
      cooperative_account_tip1: 'Assign Devices to Sub-account',
      cooperative_account_tip2: 'Independently Managed Device',
      cooperative_account_tip3: 'Publish the App as a Developer',
      admin_mailbox: 'Admin Mailbox',
      control_account_tip2: 'Assign Operators to the Sub-account',
      control_account_tip4: 'The parent account can control it at will',
      cooperative_account: 'Controlled Accounts',
      app_market_tip1: 'Select a method to control [Control Sub-account] the Apps available to the Sub-accounts',
      app_market_free: 'Completely independent and free App market',
      free_tip: 'Sub-account chooses Apps from the list of Apps available on the App market. No control on Apps available for download by sub-accounts.',
      clone_tip: 'Apps available to the sub-account will be exactly the same as the parent account, including the seting position of the auto-installed Apps. The sub-account’s [App List] cannot be operated and managed, only for display',
      app_market_choose: 'Select from the App market of the parent account',
      choose_tip: 'Sub-account only selects from the Apps available on the main Parent account channel',
      app_market_parent: 'Parent account sets up Apps for sub-account',
      parent_tip: 'Apps available to Sub-account are completely fixed and decided by the parent account. The sub-account’s [App List] cannot be operated and managed, only for display',
      app_market_tip2: 'Transfer to a controlled sub-account into an independent sub-account',
      transfer: 'Transfer',
      transfer_to_cooperative: 'Transfer to an independent sub-account',
      transfer_tip: 'Controlled sub-accounts can be converted into independent sub-mergers, and the management rights will be returned to the sub-accounts. After conversion, they will no longer be able to switch back to controlled sub-accounts.',
      setting: 'Set',
      app_market_clone: 'Clone the Apps of the parent account',
      to_management: 'To Manage',
    },

    operate:{
      search_tip: 'Enter Nickname or Mailbox to Search',
      operate_name: 'Name',
      operate_email: 'Email',
      operate_role: 'Role',
      operate_permission: 'Permission',
      operate_status: 'Status',
      operate_operate: 'Operation',
      operate_admin: 'Administrator',
      operate_operator: 'Operator',
      operate_status_no_active: 'Not Activated',
      operate_status_active: 'Active',
      operate_permission_select: 'Select Permission',
      admin_all_permission: 'All Permissions',
      operate_del_tip: 'This operation will delete the operator. Continue or not? ',
      operate_admin_password_tip: 'Please enter the current administrator’s password',
      operate_transfer_admin_tip: 'This operation will delete the operator. Continue or not?',
      operate_email_transfer_select_tip: 'Please select the operator to be transferred',
      add_operator: 'Add an Administrator',
      transfer: 'Transfer',
      remove: 'Remove',
      transfer_permission: 'Transfer Permission',
      transfer_permission_tip: 'Please select a new administrator. After transfer, the account will lose the administrator’s permission',
      operate_permission_select_tip: 'Please select the function module that the operator has access to',
    },
    personalinfo:{
      reset: 'Reset',
      personal_current_password: 'Current Password',
      enterOldPass:'Please enter current password',
      personal_new_password: 'New Password',
      personal_again_password: 'Repeat the Password',
      personal_new_password_tip: 'Please enter a new password',
      personal_again_password_tip: 'Please confirm your password',
      personal_name: 'Name',
      personal_name_tip: 'Please enter a user name',
      personal_new_email: 'New Mailbox',
      personal_again_email: 'Repeat Mailbox',
      personal_new_email_tip: 'Please enter a new mailbox',
      personal_again_email_tip: 'Please confirm the new mailbox',
      personal_tel_concate: 'Contact Telephone',
      personal_tel_concate_tip: 'Please enter the contact telephone',
      password_change: 'Password Change',
      password_change_tip: 'Please change password regular to keep account save.',
      display: 'Display',
      hide: 'Hide',
      email_binding: 'Binding Email',
      email_binding_tip_one: 'Your Mailbox',
      tel_binding: 'Bind Telephone Number',
      tel_binding_already: 'Bounded',
      tel_binding_no: 'Unbound',
      tel_rule: 'Please enter the phone number',
      email_binding_tip_two: 'If it has been disabled, please replace it immediately to avoid the theft of the account.',
    },

    deviceMap:{
      search_dropdown: 'Drop-down Menu',
      device_map_merchant: 'Account',
      device_map_sn: 'SN',
      device_total_num: 'Total Devices',
      export_details:'Export Device Location',
      company_address_distributed: 'Business Address Distribution',
      device_address_distributed: 'Device Location Distribution',
      export_excel_name:'Device Location Report',
    },

    // 参数配置
    param:{
      add:'Add',
      delete:'Delete',
      config_name:'Config Name',
      push_range:'Push Range',
      push_status:'Push Status',
      finish_schedule:'Status',
      create_time:'Create Time',
      push:'Push',
      clone_config:'Clone',
      edit_config:'Edit',
      more_option:'More',
      param_clone:'Parameter Clone',
      view_param:'Parameter View',
      clone_tip:'You are about to clone this parameter configuration, do you want to continue?',

      scan:'View',
      operation:'Operation',
      part_push:'PART',
      all_push:'All',
      has_pushed:'Pushed',
      no_push:'Unpushed',
      add_param:'Add Parameter',
      import:'Import',
      export:'Export',
      download_template:'Download Template',
      upload_param_config_tip:'Please select the file to upload',
      no:'SN',
      param_name:'Parameter Name',
      param_type:'Parameter Type',
      param_value:'Parameter Content',
      param_remark:'Remarks',
      param_edit:'Edit',
      save_and_return:'Save and return',
      type_of_text:'Text',
      type_of_switch:'Switch',
      open:'Open',
      off:'Close',
      enter_param_name_tip:'Please enter the parameter name',
      enter_param_value_tip:'Please enter the parameter content',
      enter_param_remark_tip:'Please enter parameter remarks',
      enter_config_name:'Please enter a name',
      enter_config_path:'Please enter the path',


      add_param_title:'New parameter',
      edit_param_title:'Edit parameter',
      import_param_title:'Import parameters',
      param_config:'Parameter configuration',
      param_add_name:'Name',
      param_add_path:'Path',
      param_version:'Version',
      param_name_duplicate:'Parameter name is duplicated',
      param_name_empty:'The parameter name cannot be empty',
      param_value_empty:'The parameter value cannot be empty',
      config_name_empty:'The name cannot be empty',
      import_tmp_error:'Import failed, please import the correct template format',
      param_path_empty:'Path cannot be empty',
      param_list_empty:'The parameter list cannot be empty',
      record_return:'Return',
      confirm:'OK',
      cancel:'Cancel',
      record:'Record',
      push_content:'Push content',
      delete_app_param:'Delete parameter configuration',
      delete_app_param_tip:'Are you sure you want to delete the selected parameter configuration? ',
      return_tip:'Tip',
      can_not_clone_tip:'The rule you just cloned will not be created, are you sure to return?',
      return_not_save:'Return',
      add_app_param_return_tip:'Are you sure to return?',
      download_error_import_excel:'Download error data',
    },
    usageRecord: {
      documentDistribution: '[File Distribution]',
      uninstallApp: '[Uninstall Apps]',
      deviceDisable: '[Disable Devices]',
      deviceUndisable: '[Undisable Devices]',
      deviceShutdown: '[Shutdown Devices]',
      deviceRestart: '[Restart Devices]',
      deviceMove: '[Move Devices]',
      deviceLog: '[Device Log]',
      messagePush:'[Message Push]',
      bootLogo:'[Boot Logo]',
      device_groupDevice_ring:'[Device Ring]',
      deviceWifi: '[WIFI Configuration]',
      lateTaskExpired: 'Late Task Expires',
      hasTaskExpired: 'Task has Expired',
      taskHasFinish: 'Task Completed',
      moveToDeviceGroup: 'Move to the device group:',
      uninstallAppName: 'Name of the uninstalled app:',
      appVersion: 'Version:',
      fileName: 'File Name:',
      fileSize: 'File Size:',
      targetPath: 'Target Path:',
      isCoverYes: 'Cover or not: Yes',
      isCoverNo: 'Cover or not: No',
      isRemindYes: 'Remind the other party or not: yes',
      isRemindNo: 'Remind the other party or not: No',

      executed: 'To be Executed',
      execution_succeed: 'Execution Success',
      execution_failed: 'Failed Execution',
      clear_task_completed: 'The task of [Clear lock screen password] has been completed! ',
      clear_task_pending: 'The task of [Clear lock screen password] task is pending to execute! ',
      uninstall_app_tip: 'Fill in the name of the app package to be uninstalled. Only one is allowed (for example: ffsdsssd.dasdasd.sadasd)',
      app_package_confirm: 'Please confirm the accuracy of the package name',
      fail_overtime: 'Times Out',
      fail_refuse: 'App end Refuse',
      fail_notexist: 'No such Application',
      fail_upinstall: 'Uninstall Failed',
      fail_forcestop: 'Force Stop',
      fail_download: 'Download Failed',
      check_log_file:'View Log',
    },

    remoteManage:{
      shutdown : 'Shutdown',
      restart: 'Restart',
      uninstallApp: 'Uninstall App',
      documentDistribution: 'Files Distribution',
      deviceInfo: 'Device Information',
      nativeInfo: 'Native Information',
      dvcType: 'Device Type',
      snNumber: 'SN Number',
      sn_jd:'S/N',
      jd_device_info:'Device Information',
      sysVersion: 'System Version',
      seVersion: 'SE Version',
      basebandVersion: 'Baseband Version',
      kernelVersion: 'Kernel Version',
      screenResolution: 'Screen Resolution',
      currentPosition: 'Current Location',
      electricity: 'Battery Life',
      hardwareInformation: 'Hardware Information',
      dvcMemory: 'Device Memory',
      storage: 'Storage',
      networkStatusInfo: 'Network Status Information',
      SIMCardNum: 'SIM Card Serial Number',
      operator: 'Operator',
      MACAddress: 'MAC Address',
      IPAddress: 'IP Address',
      application: 'Application',
      thirdApp: 'Third-party Application',
      systemApp: 'System Application',
      appName: 'App Name',
      versionNum: 'Version Number',
      packageName: 'Package Name',
      size: 'Size',
      deleteDvcGroup: 'Delete Device Group',
      deleteDvcGroupTips: 'You will delete the device group. Are you sure to delete? ',
      remoteDesktop:'Start Remote',
      remoteDesktopRefuse:'Device rejected remote connection request',
      remoteDesktopControl:'remotely controlling device',
      connectTiming:'Connection timed out',
      stopConnect:'disconnect this connection,do not refresh the page',



    },

    status:{
      online: 'Online',
      offline: 'Offline'
    },

    addressManage:{
      fences_range: 'Fence Range',
      fences_range_lng: 'Fence Longitude',
      fences_range_lat: 'Fence Latitude',
      fences_range_radius: 'Fence Radius',
      fence_switch: 'Fence Switch',
      fence_switch_close: 'Close',
      fence_switch_open: 'Open',
      fence_range_out_limit: 'Action for Out of Fence',
      mobile_data: 'Disable Mobile Communication',
      screen: 'Device Disabled',
      bluetooth: 'Disable Bluetooth',
      restore_device_date: 'Restore factory data regularly',
      add: 'Add',
      save:'Save',
      change_deviceGroup_tip: 'Do you want to save the last edit? ',
      meter:'meter',
      checkFrequency:'Email sending frequency',
      enterCheckFrequency:'Please fill in the email sending frequency',
      receiveEmail:'Receive E-mail',
      enterWarnEmail:'Please enter the email to receive the alert',

    },

    appWhitelist:{
      name:'Name',
      content:'Application Selection',
      app_name:'Name',
      app_version:'Version',
      app_package:'Package',
      add_app:"Add application",
      app_name_is_empty:"App name cannot be empty",
      app_version_is_empty:"App version cannot be empty",
      app_package_is_empty:"Application package name cannot be empty",
      app_content_is_have_one:"Keep at least one piece of data",

      app_whitelist_name_is_empty:"App whitelist name is empty",
      app_whitelist_content_is_empty:"App whitelist content is empty",

      app_whitelist_del_tip:"Confirm to delete the application whitelist",
    },

    flowManage:{
      flowUsage:'Flow Usage',
      appRank:'Application Rank',
      groupRank:'Group Rank',
      exportReport:'Export Report',
      date:'Date',
      start_date:'Start Date',
      end_date:'End Date',
      totalUsage:'Total Usage',
      dayUsagePerDvc:'Daily Flow per Device',
      rank:'Rank',
      group:'Group',
      parentGroup:'Parent Group',
      percent:'Percent',
      operate:'Operation',
      appName:'App Name',
      appPackage: 'App Package',
      periodTotalFlow:'Period Total Flow',
      dvcNum:'Device Number',
      periodDayFlow:'Period Daily Flow',
      dvcDayFlow:'Daily Flow per Device',
      periodGroupFlowUsage:'Period Device Flow Usage Of Selected Group',
      periodAppFlowUsageRank:'Period Device App Flow Usage Rank',
      dvcSnCode:'Device SN Number',
      selectGroup:'Select Group',
      unitMb:'Unit：Mb',
      selectRankGroup:'Select The Group For The Ranking',
      groupTip:'Tip: The Data Contains All The Devices Below This Group And Its Subgroups',
      childGroupUsageDetail:'Child Group Flow Usage Detail',
      currentGroup:'Current Group',
      selectTwoMoreGroup:'Please Select Two Groups At Least',
      nought:'Null',
      allGroup:'All Group',
      selectDate:'Please Select A Date',
      startDayBeforeEndDay:'The Start Day Shoule Be Prior To End Day',




    },

    platformSetting:{
      data_cache_setting:'Data Cache Settings',
      data_cache_setting_power_clean:'Electricity Info validity period',
      data_cache_setting_address_clean:'Location Info validity period',
      data_cache_setting_log_clean:'Operation log validity period',
      data_cache_setting_app_clean:'Application Info validity period',
      data_cache_setting_power_cache:'Electricity Info cache frequency',
      data_cache_setting_day:'day',
      data_cache_setting_minute:'Minutes',
      data_cache_setting_error_tip:'The number of days in the data cache setting must be a positive integer and cannot be greater than 30',
      data_cache_setting_power_error_tip:'The valid period of battery information is 0-360 days',
      data_cache_setting_power_error_tip_empty:'The valid period of battery information can not be empty',
      data_cache_setting_log_error_tip:'The validity period of the operation log is 30-360 days',
      data_cache_setting_power_cache_frequency:'Electricity information cache frequency should be positive integer',
      data_cache_setting_log_error_tip_empty:'The validity period of the operation log can not be empty',
      platform_setting:'Security Settings',
      platform_setting_tip:'Password attempts',
      platform_setting_time:'Times',
      platform_setting_submit:'Application',
    },

    logManage:{
      log_add:"Add Log Task",
      log_query:"Query",
      sn:"SN",
      sn_tip:"Please enter SN",

      device_type:"Type",
      device_type_tip:"Please select a device type",

      task_time:"Time",
      task_time_tip:"Please select a time range",

      status:"Status",
      status_tip:"Please select a status",

      status_finish:"Completed",
      status_push:"Pushing",
      status_execution:"In Execution",
      status_no_response:"Device Not Responding",
      status_forced_stop:"Forced Stop",
      status_file_is_not_exists:"File does not exist",

      operate_download_log:"Download Log",
      operate_reset:"Retry",
      operate_force_stop:"Terminate Operation",

      table_sn:"SN",
      table_device_type:"Device Type",
      table_remark:"Device Notes",
      table_log_type:"Log Type",
      table_create_time:"Create Time",
      table_start_time:"Start Time",
      table_end_time:"End Time",
      table_status:"Status",
      table_operate:"Operate",

      log_type_utms:"UTMS Log",
      log_type_system:"System Log",
      log_type_file:"Specified File",

      log_type_utms_tip_1:"This operation is about to fetch device logs. Continue?",
      log_type_utms_tip_2:"It takes a certain amount of time to upload the log file. After it is completed, it will be downloaded in the log record.",

      log_type_system_start_time:"Starting Time",
      log_type_system_continued_time:"Duration",
      log_type_system_record_log:"Log",
      log_type_system_log_main:"main log",
      log_type_system_log_main_tip:"(Kernel and root privilege operation logs)",
      log_type_system_log_radio:"radio log",
      log_type_system_log_radio_tip:"(RF communication module communication log)",
      log_type_system_log_system:"system log",
      log_type_system_log_system_tip:"(OS log)",
      log_type_system_log_events:"events log",
      log_type_system_log_events_tip:"(Event logs, such as touch screen click events, etc.)",
      log_type_system_file_size:"File Limit",
      log_type_system_file_rule:"File Rules",
      log_type_system_file_rule_1:"Delete file after upload",
      log_type_system_file_rule_2:"Notify device after upload",

      log_type_system_start_time_type_tip:"Please select a start time",
      log_type_system_continued_time_tip:"Please enter a duration",
      log_type_system_continued_time_tip1:"Duration must be greater than 0",
      log_type_system_continued_time_tip2:"Please select a time unit",
      log_type_system_record_log_tip:"Please tick the logging category",
      log_type_system_file_size_tip:"Please enter file limit",
      log_type_system_file_size_tip1:"Eile limit must be greater than 0",

      log_type_file_path:"Target Path",
      log_type_file_path_format:'Format such as: /sdcard/MDM',
      log_type_file_path_tip:"The above is the specified path for file storage on the device side! ",
      log_type_file_file_rule:"File Rules",
      log_type_file_file_rule_1:"Delete file after upload",

      log_type_file_path_error_tip:"Please enter the destination path",
      log_type_file_path_error_tip1:"The destination path is invalid, please enter a valid path",

      log_time_min:"Minute",
      log_time_hour:"Hour",
      log_time_day:"Day",

      add_table_sn:"SN",
      add_table_device_type:"Device Type",
      add_table_status:"Status",

      add_table_add_tip:"Please select data in the table on the left",
      add_table_remove_tip:"Please select data in the table on the right",

      modal_add_log:"Extract device logs",
      modal_select_device:"Select Device",
      modal_log_task:"Log Task",

      modal_button_add:"Add",
      modal_button_delete:"Remove",
      modal_button_cancel:"Cancel",
      modal_button_next:"Next",
      modal_button_sure:"Sure",

      device_status_on:"Online",
      device_status_off:"Offline",

      modal_tip_select_dvcId_empty:"Select the number of devices is empty",

      tip:"Tip",
      tip_content_forced_stop:"This operation will stop collecting logs, whether to continue?",
      tip_content_reset:"This operation will re-push log collection, whether to continue?",

      log_download:'download',
    },
  },
  device: {
    messagetype: {
      all : 'All',
      inbox: 'Inbox',
      sent : 'Send',
      draft: 'Draft',
      outbox: 'Outbox',
      failed: 'Send failed',
      queued: 'Queued'
    },
    calltype: {
      incoming: 'Incoming',
      outgoing: 'Outgoing',
      missed: 'Missed',
      voicemail: 'Voicemail',
      rejected: 'Rejected',
      blocked: 'Blocked',
      answerexternally: 'Answer externally'
    }
  },
  time:{
    year0: 'Year',
    month0: 'Month',
    day0: 'Day',
    hour0: 'Hour',
    min0: 'Minute',
    sec0: 'Seconds'
  },
  alert:{
    msg0: 'Alert',
    confirm0: 'confirm',
    cancel0: 'Cancel',
    appRepet1: 'Sorry! The APK you uploaded',
    appRepet2: 'Already exists. ',
    appRepet3: 'This application is indeed owned by your company, please send an email to ',
    appRepetMail: 'uhome@urovo.com',
    appRepet3_1: 'Claim the app. Once the claim is successful, the app will be transferred under your name and retain the full data. ',
    appRepet4: 'App with the same name:',
    appRepet5: 'Format of claimed mail:',
    appRepet6: 'Title: App claim',
    appRepet7: 'Email body: App claim - App with the same name (package name), contact person, contact telephone. Add the company’s business license, corresponding software copyright certificate, etc. to the attachment',
  },

//elementui: Internationalization attribute coverage
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }
  },

//国家/地区
  area:{
    Angola:'Angola',
    Afghanistan:'Afghanistan',
    Albania:'Albania',
    Algeria:'Algeria',
    Andorra:'Andorra',
    Anguilla:'Anguilla',
    Antigua_and_Barbuda:'Antigua and Barbuda',
    Argentina:'Argentina',
    Armenia:'Armenia',
    Ascension:'Ascension',
    Australia:'Australia',
    Austria:'Austria',
    Azerbaijan:'Azerbaijan',
    Bahamas:'Bahamas',
    Bahrain:'Bahrain',
    Bangladesh:'Bangladesh',
    Barbados:'Barbados',
    Belarus:'Belarus',
    Belgium:'Belgium',
    Belize:'Belize',
    Benin:'Benin',
    Bermuda_Is:'Bermuda Is',
    Bolivia:'Bolivia',
    Botswana:'Botswana',
    Brazil:'Brazil',

    Brunei:'Brunei',
    Bulgaria:'Bulgaria',
    Burkina_Faso:'Burkina Faso',
    Burma:'Burma',
    Burundi:'Burundi',
    Cameroon:'Cameroon',
    Canada:'Canada',
    Cayman_Is :'Cayman Is',
    Central_African_Republic:'Central African Republic',
    Chad:'Chad',
    Chile:'Chile',
    China:'China',
    Colombia:'Colombia',
    Congo:'Congo',
    Cook_Is:'Cook Is',
    Costa_Rica:'Costa Rica',
    Cuba:'Cuba',
    Cyprus:'Cyprus',
    Czech_Republic:'Czech Republic',
    Denmark:'Denmark',
    Djibouti:'Djibouti',
    Dominica_Rep:'Dominica Rep',
    Ecuador:'Ecuador',
    Egypt:'Egypt',
    EI_Salvador:'EI Salvador',
    Estonia:'Estonia',
    Ethiopia:'Ethiopia',
    Fiji:'Fiji',
    Finland:'Finland',
    France:'France',
    French_Guiana:'French Guiana',
    French_Polynesia:'French Polynesia',
    Gabon:'Gabon',
    Gambia:'Gambia',
    Georgia:'Georgia',
    Germany:'Germany',
    Ghana:'Ghana',
    Gibraltar:'Gibraltar',
    Greece:'Greece',
    Grenada:'Grenada',
    Guam:'Guam',
    Guatemala:'Guatemala',
    Guinea:'Guinea',
    Guyana:'Guyana',
    Haiti:'Haiti',
    Honduras:'Honduras',
    Hungary:'Hungary',
    Iceland:'Iceland',
    India:'India',
    Indonesia:'Indonesia',
    Iran:'Iran',
    Iraq:'Iraq',
    Ireland:'Ireland',
    Israel:'Israel',
    Italy:'Italy',
    Ivory_Coast:'Ivory Coast',
    Jamaica:'Jamaica',
    Japan:'Japan',
    Jordan:'Jordan',
    Kampuchea:'Kampuchea',
    Kazakstan:'Kazakstan',
    Kenya:'Kenya',
    Korea:'Korea',
    Kuwait:'Kuwait',
    Kyrgyzstan:'Kyrgyzstan',
    Laos:'Laos',
    Latvia:'Latvia',
    Lebanon:'Lebanon',
    Lesotho:'Lesotho',
    Liberia:'Liberia',
    Libya:'Libya',
    Liechtenstein:'Liechtenstein',
    Lithuania:'Lithuania',
    Luxembourg:'Luxembourg',
    Madagascar:'Madagascar',
    Malawi:'Malawi',
    Malaysia:'Malaysia',
    Maldives:'Maldives',
    Mali:'Mali',
    Malta:'Malta',
    Mariana_Is:'Mariana Is',
    Martinique:'Martinique',
    Mauritius:'Mauritius',
    Mexico:'Mexico',
    Moldova:'Moldova',
    Monaco:'Monaco',
    Mongolia:'Mongolia',
    Montserrat_Is:'Montserrat Is',
    Morocco:'Morocco',
    Mozambique:'Mozambique',
    Namibia:'Namibia',
    Nauru:'Nauru',
    Nepal:'Nepal',
    Netheriands_Antilles:'Netheriands Antilles',
    Netherlands:'Netherlands',
    New_Zealand:'New Zealand',
    Nicaragua:'Nicaragua',
    Niger:'Niger',
    Nigeria:'Nigeria',
    North_Korea:'North Korea',
    Norway:'Norway',
    Oman:'Oman',
    Pakistan:'Pakistan',
    Panama:'Panama',
    Papua_New_Cuinea:'Papua New Cuinea',
    Paraguay:'Paraguay',
    Peru:'Peru',
    Philippines:'Philippines',
    Poland:'Poland',
    Portugal:'Portugal',
    Puerto_Rico:'Puerto Rico',
    Qatar:'Qatar',
    Reunion:'Reunion',
    Romania:'Romania',
    Russia:'Russia',
    Saint_Lueia:'Saint Lueia',
    Saint_Vincent:'Saint Vincent',
    Samoa_Eastern:'Samoa Eastern',
    Samoa_Western:'Samoa Western',
    San_Marino:'San Marino',
    Sao_Tome_and_Principe:'Sao Tome and Principe',
    Saudi_Arabia:'Saudi Arabia',
    Senegal:'Senegal',
    Seychelles:'Seychelles',
    Sierra_Leone:'Sierra Leone',
    Singapore:'Singapore',
    Slovakia:'Slovakia',
    Slovenia:'Slovenia',
    Solomon_Is:'Solomon Is',
    Somali:'Somali',
    South_Africa:'South Africa',
    Spain:'Spain',
    SriLanka:'SriLanka',
    St_Lucia:'St Lucia',
    St_Vincent:'St Vincent',
    Sudan:'Sudan',
    Suriname:'Suriname',
    Swaziland:'Swaziland',
    Sweden:'Sweden',
    Switzerland:'Switzerland',
    Syria:'Syria',
    Tajikstan:'Tajikstan',
    Tanzania:'Tanzania',
    Thailand:'Thailand',
    Togo:'Togo',
    Tonga:'Tonga',
    Trinidad_and_Tobago:'Trinidad and Tobago',
    Tunisia:'Tunisia',
    Turkey:'Turkey',
    Turkmenistan:'Turkmenistan',
    Uganda:'Uganda',
    Ukraine:'Ukraine',
    United_Arab_Emirates:'United Arab Emirates',
    United_Kiongdom:'United Kiongdom',
    United_States_of_America:'United States of America',
    Uruguay:'Uruguay',
    Uzbekistan:'Uzbekistan',
    Venezuela:'Venezuela',
    Vietnam:'Vietnam',
    Yemen:'Yemen',
    Yugoslavia:'Yugoslavia',
    Zimbabwe:'Zimbabwe',
    Zaire:'Zaire',
    Zambia:'Zambia',
  },


  // 机构相关
  org: {
    orgTree: {
      title_create: 'Create Sub-organization(Merchant)',
      placeholder_filter: 'Please enter the organization or business name',
      check_box_inter: 'Parent-Child',
      check_box_inter1: 'All',
      form_superiorOrgName: 'Superior Org Name：',
      form_orgType: 'Org Type：',
      form_orgType_SubOrganization: 'Sub-Organization',
      form_orgType_Merchant: 'Merchant',
      form_orgName: 'Org Name：',
      form_orgName_placeholder: 'Please type the name of organization(merchant)',
      form_merchant_placeholder: 'Please type the merchant id',
      form_admin_email: 'Admin Email：',
      form_admin_email_help: 'original password used to manage the organization will delivered by this email',
      form_admin_email_placeholder: 'Please type the admin email',
      form_contactsName: 'Contacts Name：',
      form_contactsName_placeholder: 'Please type the contacts name',
      form_contacts_phone: 'Phone：',
      form_contacts_phone_placeholder: 'Please type the contacts phone：',
      form_address: 'Address：',
      form_address_placeholder: 'Please type the address',
      form_remarks: 'Remarks：',
      form_remarks_placeholder: 'Please type the remarks',
      form_btn_create: 'Create',
      form_btn_cancel: 'Cancel',

      validate_msg_orgName: 'Please type the name of organization',
      validate_msg_orgName_too_long: 'length of name of organization should less than 125',
      validate_msg_email: 'Please type the right format of email',
      validate_msg_email_required: 'Please type the email',
      validate_msg_merId: 'length of merchant id should less than 32',
      validate_msg_contactsName: 'length of contacts name should less than 100',
      validate_msg_contactsPhone: 'Please type the right format of phone',
      validate_msg_address: 'length of address should less than 100',
      validate_msg_remarks: 'length of remarks should less than 100',

      add_org_success: 'Creating organization success',

      detail_form_title: 'Details',
      detail_form_title_merchant: 'Details',
      detail_form_bind_device: 'Bound Devices',
      detail_form_storage_device: 'Stocked Devices',
      detail_form_orgName: 'Group：',
      detail_form_orgName_placeholder: 'Please type the organization name',
      detail_form_merchantName: 'MerchantName：',
      detail_form_merchantName_placeholder: 'Please type the name of merchant',
      detail_form_btn_save: 'Save',
      detail_form_btn_delete_org: 'Delete',
      detail_form_btn_delete_merchant: 'Delete',
      detail_form_btn_create_child: 'Create Sub-Group',

      detail_delete_error_title: 'Delete Organization Fail',
      detail_delete_error_title_2: 'Delete Merchant Fail',
      detail_delete_btn_ok: 'OK',
      detail_delete_warning: 'Warning',
      detail_delete_msg_one: 'Delete Organization(Merchant)：',
      detail_delete_msg_two: '，whose devices will be unbound, and moved to the parent organization, are you sure ?',
      detail_delete_btn_confirm: 'Delete',
      detail_delete_btn_cancel: 'Cancel',

      detail_delete_success: 'Deleting Option Success',
      detail_update_success: 'Updating Option Success',

      excel_btn_upload: 'Bulk Upload',
      excel_title_upload: 'Bash Upload Organization(Merchant)',
      excel_check_clear: 'UpdateAlreadyExists',
      excel_download_excel: 'Download Excel Template',
      excel_tips_upload: 'Drag excel file or click here to select',
      excel_btn_cancel: 'Cancel',
      excel_title_error: 'BashUploadError',
      excel_btn_ok: 'OK',

      excel_table_rowAndCol: 'RowAndColNumber',
      excel_table_reason: 'Reason',
      excel_table_title_1: 'Bulk Unbind',
      excel_table_column_sn: 'SN',
      excel_table_column_time: 'Bound Time',
      excel_table_column_orgName: 'Organization Name',

      btn_batch_unbind: 'Bulk Unbind',
      btn_batch_cancel: 'Cancel',
      excel_download_template: 'Download Template',

      modal_batch_unbind_title: 'Warning',
      modal_batch_unbind_btn_confirm: 'Confirm',
      modal_batch_unbind_msg: 'If you unbind the devices, all data will be deleted, please be careful.',
    },
    expendRow: {
      dvcType: 'Device Type:',
      orgAndMerchant: 'ORG/Merchant:',
      status: 'Status:',
      status_normal: 'Normal',
      status_forbidden: 'Forbidden',
      push_org: 'Group Push',
      push_sn: 'TID/SN Push',
      config_valid: 'Valid',
      config_invalid: 'Invalid',
      delete_row: 'Delete',
      delete_column: 'delete',
      delete_warnning: 'Warning',
      placeholder: 'Please enter the key word for searching',
      btn_add: 'Add',
      btn_batch: 'Bulk Add',
      table_row_operation: 'Operation',
    }
  },
  // 设备仓库相关
  deviceRepository: {
    search: {
      manufacturer_name: 'ManufactureName：',
      manufacturer_name_placeholder: 'Please select Manufacture',
      device_type: 'DeviceType：',
      device_sn: 'SN：',
      device_sn_placeholder: 'Please enter sn to search',
      device_type_placeholder: 'Please select device type',
      add_time: 'Stock in Time：',
      add_time_bind: 'BindTime：',
      add_time_placeholder: 'Please select date',
      btn_search: 'Search',
    },
    add: {
      btn_add_one: 'Single Activation',
      modal_add_one: 'StoreOneDevice',
      form_org_name: 'Organization：',
      form_manufacturer_name: 'Manufacturer：',
      form_manufacturer_name_placeholder: 'Please select manufacturer',
      form_device_type: 'DeviceType：',
      form_device_type_placeholder: 'Please select device type',
      form_device_sn: 'SN：',
      form_device_sn_placeholder: 'Please entry SN',
      form_device_tid: 'TID：',
      form_device_tid_placeholder: 'Please entry TID',
      form_device_remark: 'Remark：',
      form_device_remark_placeholder: 'Please entry remark',
      form_btn_add: 'AddToStorage',
      form_btn_cancel: 'Cancel',

      validate_sn: 'Please input the sn',
      validate_sn_too_long: 'Length of sn should less than 50',
      validate_tid_too_long: 'Length of tid should less than 50',
      validate_remark_too_long: 'length of remark should less than 300',
      validate_manufacture: 'Please select manufacture',
      validate_device_type: 'Please select device type',

      add_success: 'Add to repository success',
    },
    table: {
      storage_time: 'Stock in Time',
      bind_time: 'BindTime',
      manufacturer_name: 'Manufacturer',
      device_type: 'DeviceType',
      operator: 'Operator',
      remark: 'Remark',
    },
    bash: {
      btn_bash_storage: 'Bulk Activation',
      modal_title_bash_storage: 'BashStore',
      modal_btn_download: 'Download Template',
      modal_tips_upload: 'Drag excel file or click here to select',
      modal_btn_cancel: 'Cancel',
      excel_title_error: 'BashStorage Error',
      excel_btn_ok: 'OK',
      excel_msg_success: 'Operation Success',
    },
    storageMove: {
      btn: 'Move Storage',
      btn1: 'Bulk Move',
      modal_title: 'StorageMoveTo',
      modal_title1: 'StorageBatchMoveTo',
      modal_btn_move: 'Move',
      modal_btn_cancel: 'Cancel',
      modal_success: 'StorageMove Success'
    },
    deviceBind: {
      btn: 'Bind Devices',
      btn1: 'Bulk Bind',
      modal_title: 'BindDevicesTo',
      modal_btn_bind: 'Bind',
      modal_btn_cancel: 'Cancel',
      modal_btn_next: 'Next',
      modal_btn_pre: 'Previous',
      modal_step_1: 'Complete Info(optional)',
      modal_step_2: 'Select Entity',
      modal_success: 'Binding Service Success',
    },
    deviceUnbind: {
      btn: 'Unbind',
      tip: 'Tips',
      tip_msg: 'Unbind devices will clear the settings of devices selected and move them to storage, are your sure?',
      btn_unbind: 'Unbind',
      btn_cancel: 'Cancel',
      success_msg: 'Unbind devices success',
    },
    deviceDelete: {
      btn: 'Delete Devices',
      btn1: 'Bulk Delete',
      tip: 'Tips',
      tip_msg: 'Delete devices wile remove the devices from system, are you sure？',
      btn_delete: 'Delete',
      btn_cancel: 'Cancel',
      success_msg: 'delete successful ',
      fail_msg: 'delete failure',
    }
  },
  //应用相关
  app:{
    list:{
      no_select:'Please select at least one app',
    },
    check :{
      auto_mode:'Auto Review',
      manual_mode:'Manual Review',
      refuse_check:'Fail Review',
      oprate_tip:'Tip',
      add_balcklist_tip:'Is it added to the audit blacklist?',
      check_mode:'Audit Mode',
      view_black_list:'Blacklist',
      check_progress:'Review Progress',
      putin_app_name:'Please enter the application name',
      search:'Search',
      app_name:'App Name',
      app_version_code:'App Version',
      app_version_name:'Version Name',
      sign_mode:'Signature',
      submit_user:'Submitted User',
      submit_time:'Submitted Time',
      progress:'Progress',
      operate:'Operating',
      sign_no:'Primitive',
      sign_yes:'Signature',
      wait_check:'Under review',
      pass_check:'Passed',
      no_pass_check:'Failed',
      app_package:'App Package',
      remove_app_blacklist:'Remove from the Blacklist',
      no_pass_tip:'Audit result: The application audit failed! ',
      fail_reason:'Reason for failure',
      no_check:'Unchecked',
      click_icon_tip:'Click the icon to edit application information',
      app_in_version:'Version',
      ing_check:'Under Review',
      check_pass:'Passed',
      check_no_pass:'Failed',
      app_download:'Download',
      apply_push:'Apply to Publish',
      cancel_apply:'Withdraw',
      wait_check_tip:'The review takes 3-5 working days, please be patient! ',
      re_apply_check:'Reapply',
      re_apply_confirmation:'Do you want to apply for approval again?',
      push_apply_confirmation:'Post application confirmation',
      apply_confirmation_tip:'After the application is posted, the review takes 3-5 working days, please be patient.',
      cancel_check_apply:'Withdraw the review application',
      cancel_apply_tip:'The application is waiting for the administrator to review. Do you want to withdraw the application? ',
      has_shelf_app:'Added Application',
      app_unshelf:'Remove',
      no_shelf_app:'Not Added Application',
      app_shelf:'Add',
      app_detail:'Details',
      app_version:'Version',
      app_shelf_org:'Group Add',
      app_org_select:'Group Select',
      add_inside_app:'Add App',
      file_size:'App Size',
      eidt:'Edit',
      version_history:'Version',
      update:'Update',
      app_version_note:'Version Note',
      delete:'Delete',
      version_update:'Version Update',
      select_busstype:'Please select industry type',
      putin_app_check_note:'Please input check note .',
      detail:'Detail',
      to_blacklist:'Add blacklist',
      download:'download',
      copy_tip:'Are you sure to clone this application configuration? ',
      app_in_blacklist:'The application has been added to the blacklist',
      app_out_blacklist:'The application has been removed from the blacklist, please reapply for review',
      type_chage:'All applications will be automatically passed after the automatic review is turned on, please choose carefully! ',
      to_auto:'Do you want to enable automatic review? ',
      to_handle:'Do you open manual review? ',
      select_apk:'Please upload apk format file here',
    },
    permissions:{
      no:'Sorry, you do not have this operation permission!',
    },
  },
  //应用部署相关
  appdeploy:{
    add:{
      tip:'Select the application to be deployed',
      version:'Version:',
    },
    del:{
      del:'Delete',
      tip1:'Delete confirmation',
      tip2:'You are about to delete this configuration, do you want to continue?',
      cacel:'Cancel',
      submit:'Delete',
    },
    table:{
      progress:'Status',
      operate:'Operation',
      nopush:'Unpushed',
      yespush:'Pushed',
      record:'Record',
      allpush:'Push All',
      partpush:'Partial Push',
      inputorgname:'Please enter the organization name for query',
    },
    push:{
      push:'Push',
      cancel:'Cancel',
    },
    copy:{
      copy:'Clone',
      tip:'Select the application that needs to be deployed',
      version:'Version:',
    },
    details:{
      details:'View',
    },
    record:{
      view:'View Content',
      version:'Version',
      pushRange:'View PushRange',
      name:'Name',
      user:'Operator',
      pushrange:'Push Range',
      time:'Operation Time',
      operate:'Operation',
    },
  },
  // 日志相关
  operationLog: {
    search: {
      operator: 'Operator：',
      operator_placeholder: 'Please input the operator',
      module: 'Menu：',
      module_placeholder: 'Please select the menu',
      businessType: 'BusinessType：',
      businessType_placeholder: 'Please select the business type',
      operateTime: 'Time：',
      operateTime_placeholder: 'Please select the operate time',
      handle_status: 'Result：',
      handle_status_placeholder: 'Please select the result',
      btn_search: 'Search',
      btn_reset: 'Reset',
      operation_result_success: 'Success',
      operation_result_fail: 'Fail',
    },
    table: {
      successful: 'Successful',
      failure: 'Failure',
      operator: 'Operator',
      module: 'Menu',
      businessType: 'BusinessType',
      operatorTime: 'Time',
      content: 'Content',
      result: 'Result',
      result_succ: 'Successful',
      result_fail: 'Failure',
    }
  },
  // OTA相关
  ota: {
    menu: {
      add_os:'Upload OS',
      del_os:'Delete OS',
      refresh:'Refresh',
      add_reg:'Add',
      update_reg:'Update',
      push:'Push',
      stop:'Disabled',
      enable:'Pushed',
      disable:'Disabled',
      toBePush: 'To Be Pushed',
      download_template: 'Download Template',
      records: 'Update Records'
    },
    data:{
      yes: 'Yes',
      no: 'No',
      change_reg: 'Push Regulation',
      push: 'Push',
      change_status: 'Change Status',
      status: 'Status',
      os_id: 'OS ID',
      os_type: 'OS Type',
      dev_type: 'Device Type',
      hard_type:'hardware type',
      records_os_type: 'OS Type',
      model: 'Model',
      standard: 'Standard',
      os_version: 'OS Version',
      language: 'Language',
      bag_type: 'Package Type',
      high_version: 'Basic Version',
      upload_date: 'Upload Date',
      isForce: 'Force Update',
      isSilent: 'Silent Update',
      isImmediate: 'Immediate Update',
      period: 'Update Period',
      remind: 'Update Remind',
      remarks: 'Remarks',
      osUrl: 'OS URL',
      chinese: 'Chinese',
      english: 'English',
      change_status_success: 'Operation Successful',
      change_status_failed: 'Operation Failed',
      push_succcess: 'Push Successful',
      return_tip:'Tip',
      return_msg:'Are you sure to return?',
      clear_snRegMsg:'Are you sure to clear all SN?',
    },
    addos:{
      upload:'Version Upgrade',
      basic_os:'Basic OS Version',
      basic_os_tip: 'incremental update package require this item',
      upload_package: 'Upload Package',
      upload_package_tip: 'Upload Package (only .zip format is supported)',
      complete_package: 'Complete Package',
      incremental_package: 'Incremental Package',
      default: 'Default Period',
      timePick: 'Period of Time',
      datePick: 'Period of Date',
      eg:'example',
      save: 'Save',
      clear: 'Clear',
      back: 'Back',
      addos_success: 'Upload OS Successfully',
      validate_success:'form data validate success',
      validate_failed:'Please check input data',
      osType_msg: 'OS type can not be empty',
      devType_msg: 'Device type can not be empty',
      hardType_msg: 'Hardware type cannot be empty',
      standard_msg: 'Standard can not be empty',
      osVersionNotNull:'Version number cannot be empty',
      highVersionNotNull:'The base OS version number cannot be empty',
      osVersion_msg: 'OS version format error,please input (Android Version.YY.MMDD.xx ）format',
      osLanguage_msg: 'Language can not be empty',
      bagType_empty_msg: 'Package type can not be empty',
      path_empty_msg: 'Please select file',
      path_format_error_msg: 'File format error',
      highVersion_empty_msg: 'Incremental Package need input basic OS version',
      select_empty: 'Please select this item',
      period_empty: 'period can not be empty',
      TimePick_format_error: 'Period of Time format error',
      TimePick_size_error: 'The start time is later than the end time',
      DatePick_format_error: 'Period of Date format error',
      remind_empty: 'When no silent update is selected, update remind can not be empty',
      osVersion_format_msg: 'Please input the correct OS Version first',
      basic_os_error: 'The basic OS version must be lower than the OS version',
      //后端错误信息
      filename_notfound:'File name not found',
      file_format_error: 'File format error',
      empty_file: 'File is empty,unable to import',
      unzip_file_failed: 'File unzip failed,please reselect the file',
      upload_oss_failed: 'File upload to OSS failed',
      file_transfer_failed: 'File transfer failed',
      file_save_failed: 'File upload to server failed',
      request_failed: 'Request failed',
    },
    delos:{
      select_item: 'Select at least one item',
      delete_os: 'Delete OS',
      confirmed_del:'Are you sure to delete',
      delete_success: 'Success Delete',
      item: 'items',
    },
    snReg:{
      push_by_sn: 'Push by SN',
      push_by_org: 'Push by Organization',
      input_sn: 'Please input SN',
      add_sn: 'Add',
      import_sn: 'Import',
      back: 'Back',
      save: 'Save',
      selectAll: 'Select All',
      save_success: 'Save Success',
      clear: 'Clear',
      added_sn: 'Added SN',
      num: 'Number',
      action: 'Action',
      delete: 'Delete',
      os_info: 'OS Info',
      sn_reg: 'SN Rule Description',
      sn_reg1: '*SN must be 14 or 23 digits',
      sn_reg2: '*The first 8 digits of 14 digits SN are numbers or English letters, and the last 6 digits are pure numbers',
      sn_reg3: '*23 digits SN must start with ',
    },
    validateSN:{
      sn_format_error: 'does not match the rules',
      sn_duplicate: 'duplicate',
      sn_validate: 'Sn can only contain letters and numbers and can not be empty'
    },
    importSN:{
      import_file: 'Import File',
      select_file: 'Select file (.txt format)',
      tips1: '*only .txt file supported',
      tips2: '*It is recommended to fill in one SN in each line',
      tips3: '*Separate with "," if more than one SN in one line',
      fileMaxSize: 'The file size exceeds the limit',
      fileUploadError: 'File upload error',
      fileFormatError: 'File format error',
      import_success: 'Success import',
      item: 'items',
      cancel: 'Cancel'
    },
    records:{
      osVersion: 'OS Vesrsion',
      updateResult: 'Update Result',
      btnSearch: 'Search',
      btnReset: 'Reset',
      btnBack: 'Back',
      finishedTime: 'Finished Time',
      recordedTime: 'Recorded Time',
      success: 'Success',
      failed: 'Failure',
      failedRes: 'Failure Reason'
    }
  },
  // 设备配置相关
  deviceConfig: {
    wifiConfig: {
      push_succcess: 'Push Success',
      clone_tip_wifi: 'Tip',
      clone_content_wifi: 'Are you sure to clone this config?',
      tab_name: 'WIFI Config',
      deleteBash: {
        btn: 'Delete',
        modal_title: 'DeleteBash',
        modal_tip: 'Deleting these configs will delete these configs from devices in the same time, are you sure?',
        modal_app_param_tip:'Do you want to delete these parameter configurations? ',
        modal_btn_cancel: 'Cancel',
        modal_btn_confirm: 'Delete',
      },
      addOne: {
        btn: 'Add',
        btn1: 'Edit',
        modal_title: 'Create wifi config',
        modal_title1: 'Edit wifi config',
        form_name: 'ConfigName',
        form_name_placeholder: 'Please input the config name',
        form_ssid: 'SSID',
        form_ssid_tip:'',
        form_network_hide:'HideNetwork',
        form_network_hide_tip: 'When the target network is not open or signals are not broadcast, please enable this feature',
        form_safeType:'SafeType',
        form_safeType_tip:'Wireless network encryption type used when connecting',
        form_password:'Password',
        form_password_tip:'Password of the access point',
        qr_code_generate_tip:'Please fill in the setting information before generating the QR code',
        qr_code_generate:'QR Code',
        qr_code_generate_new_tip:'Click to generate a WIFI connection QR code. The device can scan the QR code to connect to the corresponding network.',
        form_btn_cancel:'Cancel',
        form_btn_confirm: 'Create',
        form_btn_confirm1: 'Edit',
        validate_name: 'Please input the config name',
        validate_name_too_long: 'length of config name is too long',
        validate_ssid: 'Please input the ssid',
        validate_ssid_too_long: 'length of ssid is too long',
        validate_safe_type: 'Please select the safe type',
      },
      pushRecord: {
        btn_back: "Back",
        title_record: "OperateRecord",
        table_push_type_all: "ALL",
        table_push_type_part: "PART",
        table_btn_check: "View Content",
        table_btn_range: "View PushRange",
        modal_detail: "PushContent",
        table_column_name: 'ConfigName',
        table_column_operator: 'Operator',
        table_column_version: 'Version',
        table_column_push_type: 'PushType',
        table_column_push_range: 'PushRange',
        table_column_operate_time: 'OperateTime',
        table_column_operate: 'Operation',
      },
      tableColumn: {
        push_status_unpushed: 'Unpushed',
        push_status_unpushed1: 'TID/SN',
        push_status_push: 'Pushed',
        btn_record: 'Record',
        column_config_name: 'Config Name',
        column_push_status: 'Push Range',
        column_handle_status: 'Handle Status',
        column_finis_status: 'Status',
        operation: 'Operation',
        column_push_type_all: 'Global',
        column_push_type_part: 'Partial',
        query_finish_placeholder: 'please enter the key world of organization name',
        query_finish_placeholder1: 'please enter the key world of sn',
        query_finish_placeholder2: 'please enter the key world of organization name, press enter to search',
        query_finish_placeholder3: 'please enter the key world of sn，press enter to search',
        modal_title: 'ViewPushRange',
        modal_table_column: 'OrganizationName',
        modal_table_column2: 'Override',
        modal_table_column1: 'SN',
        finish_status_modal_title: 'Status',
        finish_status_modal_search_placeholder: 'Please input SN/OrganizationName',
        finish_status_modal_re_push: 'Re-Push',
        finish_status_modal_re_push_msg: 'Re-Push config successful',
        finish_status_modal_export: 'ExportExcelFile',
        finish_status_modal_select_success: 'ExecuteSuccess',
        finish_status_modal_select_failure: 'ExecuteFailure',
        finish_status_modal_select_unhandle: 'UnExecute',
        finish_status_modal_table_column_org: 'OrganizationName',
        finish_status_modal_table_column_fail_reason:'FailReason',
        finish_status_modal_file_name_success: 'ExecutionSuccessfulDeviceList',
        finish_status_modal_file_name_failure: 'ExecutionFailDeviceList',
        finish_status_modal_file_name_unhandle: 'UnExecutionDeviceList',
        push_btn: 'Push',
        push_modal_title: 'Select Push Range',
        push_modal_cancel: 'Cancel',
        push_modal_confirm: 'Push',
        push_modal_validate: 'Please select the organizations you are will to push to',
        push_modal_validate1: 'Operation Success',
        detail_btn: 'Detail',
        detail_modal_title: 'ViewConfigDetail',
        clone_btn: 'Clone',
        delete_btn: 'Delete',
        delete_modal_title: 'DeleteConfig',
        delete_modal_msg: "Delete the config, which will delete the config from devices in the same time, are you sure?",
        delete_modal_cancel: 'Cancel',
        delete_modal_confirm: 'Delete',
      }
    },
    apnConfig: {
      tab_name: 'APN Config',
      addOne: {
        btn_name_edit: 'Edit',
        btn_name_add: 'Add',
        btn_name_clone: 'Clone',
        modal_title_one: 'CreateApnConfig',
        modal_title_one1: 'Edit Apn Config',
        modal_title_two: 'ApnConfigDetail',
        form_config_name: 'ConfigName',
        form_apn_name: 'ApnName',
        form_agent: 'Agent',
        form_port: 'Port',
        form_username: 'Username',
        form_password: 'Password',
        form_server: 'Server',
        form_mmsagent: 'MMS Agent',
        form_mmsport: 'MMS Port',
        form_authentication_type: 'AuthenType',
        form_apn_type: 'APN Type',
        form_apn_protocol: 'APN Protocol',
        form_btn_cancel: 'Cancel',
        form_btn_ok: 'Create',
        form_btn_ok1: 'Edit',
        validate_port: 'Please input the right port',
        validate_config_name: 'Please input config name',
        validate_config_name_one: 'config name should contain less than 50 characters',
        validate_apn_name: 'Please input apn name',
        validate_apn_name_one: 'apn name should contain less than 200 characters',
        validate_apn: 'Please input apn',
        validate_apn_one: 'apn name should contain less than 200 characters',
        validate_mcc: 'Please input MCC',
        validate_mcc_one: 'mcc should contain less than 200 characters',
        validate_mnc: 'Please input MNC',
        validate_mnc_one: 'mnc should contain less than 200 characters',
        validate_agent: 'agent should contain less than 200 characters',
        validate_username: 'username should contain less than 200 characters',
        validate_password: 'password should contain less than 200 characters',
        validate_server: 'server should contain less than 200 characters',
        validate_mmsc: 'mmsc should contain less than 200 characters',
        validate_mms_agent: 'MMS Agent should contain less than 200 characters',
        validate_apnType: 'APN type should contain less than 200 characters',
        authentication_type_null: 'None',
      },
      delete: {
        title: 'DeleteConfig'
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Unpushed',
        view: 'View',
        config_name: 'Config Name',
        apn_name: 'Apn Name',
        push_type: 'Push Range',
        push_status: 'Push Status',
        finish_status: 'Status',
        operation: 'Operation',
      }
    },
    customDesk: {
      btn_edit: 'Edit',
      tab_name: 'Custom Desk',
      add_modal_title_one: 'CreateCustomDesk',
      add_modal_title_one1: 'Edit Custom Desk',
      add_modal_title_one2: 'Clone Custom Desk',
      add_modal_title_two: 'CustomDeskDetail',
      add_modal_config_name: 'Name',
      add_modal_apk: 'APK',
      add_modal_tip: 'Please upload apk file whose size should less than 100M',
      add_modal_btn_cancel: 'Cancel',
      add_modal_btn_create: 'Create',
      add_modal_btn_edit: 'Edit',
      validate_config_name: 'Please enter config name',
      validate_config_name_long: 'config name should contains less than 50 characters',
      validate_apk_name: 'Please upload the apk file',
      validate_file_format: 'wrong format of the file uploaded',
      validate_file_upload_error: 'upload file error',
      validate_file_more: 'the file is too long',
      config_status_effect: 'Valid',
      config_status_invalid: 'Invalid',
      table_column_config_name: 'Config Name',
      table_column_apk_name: 'Apk Name',
    },
    function_setting: {
      on:'On',
      off:'Off',
      default_name:'Function setting',
      push_config:'Push',
      view_config:'View',
      record_config:'Record',
      edit_config:'Edit',
      clone_config:'Clone',
      part_push:'PartialPush',
      all_push:'GlobalPush',
      has_pushed:'Pushed',
      no_push:'Unpushed',
      column_name:'Config Name',
      push_range:'Push Range',
      push_status:'Push Status',
      finish_status:'Status',
      create_time:'Create Time',
      operation:'Operation',
      delete_function_tip:'Are you sure you want to delete the selected function setting?',
      delete_function_title:'Delete function settings',
      add_modal_title:'Function settings add',
      edit_modal_title:'Function settings edit',
      view_function_title:'View Function Settings',
      tab_name:'Function Settings',
      add_rule:'Add',
      delete_rule:'Delete',
      view_functionSetting:'View function setting',
      rule_name: "Rule Name",
      fcSetting_home_disable: "Disable Home Button",
      fcSetting_dropDown_disable: "Disable the drop-down status bar",
      fcSetting_bluetooth_disable: "Disable Bluetooth",
      fcSetting_wifi_disable: "Disable WIFI",
      fcSetting_MobileTraffic_disable: "Disable mobile traffic",
      fcSetting_ThirdPartyApplicationInstallation_disable: "Disable third-party application installation",
      fcSetting_camera_disable: "Disable Camera",
      fcSetting_tel_disable: "Disable Phone",
      fcSetting_message_disable: "Disable SMS",
      fcSetting_gps_disable: "Disable GPS",
      fcSetting_adb_disable: "Disable ADB",
      fcSetting_usb_disable: "Disable USB",
      fcSetting_input_disable: "Disable input method pop-up",
      fcSetting_restoreFactory_disable: "Disable factory resetting",
      fcSetting_sd_disable: "Disable SD card",
      button_confirm:'OK',
      button_cancel:'Cancel',
      operation_success:'Operation succeeded',
      function_ruleName: "Rule name cannot be empty",
      yes:'Yes',
      no:'No',
      close:'Close',
      clone_tip0:'Function setting clone',
      clone_confirm_tip:'Are you sure you want to clone this feature setting?',
      tip:'tip',
      clone_cancel_tip:'Are you sure to cancel the clone function setting?',
    },
    file_distribution: {
      edit: 'Edit',
      view_title:'File distribution view',
      device_groupDevice_fileDistribution:'Create File Distribution',
      device_groupDevice_fileDistribution1:'Edit File Distribution',
      device_groupDevice_tip7:'Only one file can be distributed at a time',
      device_groupDevice_tip10:'The specified path for file storage on the device side as above!',
      device_groupDevice_fileUpload:'File upload:',
      delete_upload_file_tip:'Please delete the file below and upload the file again',
      device_groupDevice_uploadFile:'Upload file',
      device_groupDevice_tip8:'The file size does not exceed 100M, and the file cannot be withdrawn after distribution, please be careful!',
      device_groupDevice_targetPath:'Target Path:',
      device_groupDevice_tip9:'The format is like: /sdcard/MDM',
      device_groupDevice_fileRule:'File Rule:',
      button_cancel:'Cancel',
      button_confirm:'OK',
      button_confirm1:'Edit',
      device_groupDevice_coverOriginal:'Overwrite the original file',
      device_groupDevice_tip12:'Prompt the other party after the download is successful',
      device_groupDevice_tip15:'Please upload the files that need to be distributed!',
      device_groupDevice_tip16:'Please enter the correct target path!',
      operation_success:'Operation successful',
      file_send_size_rule:'Import files must not exceed 100MB',
      delete_file:'Delete file distribution',
      delete_file_tip:'Are you sure you want to delete the selected sorting distribution? ',
      tab_name: "File Distribution",
      add:"Add",
      delete: "Delete",
      upload_file:'File upload',
      target_path:'Target path',
      file_rule:'File rule',
      cover_file:'cover the original file',
      tip_user:'Prompt the other party after the download is successful',
      config_name:'Config name:',
      download_file:'Original file:',
      download:'Download',
      enter_config_name:'Enter config name',
      device_groupDevice_tip17:'Please enter the configuration name!',
      device_groupDevice_tip18:'Please check the file rules!',

    },

    address_fence:{
      tab_name:'Geo Fence',
      rule_name:'Rule Name',
      rule_push_range:'Push Range',
      fences_range:'Fence range',
      fences_range_lng:'Fence Lng',
      fences_range_lat:'Fence Lat',
      fences_range_radius:'Fence Radius',
      meter:'Meter',
      fence_switch:'Fence Switch',
      close:'Close',
      open:'Open',
      out_of_range_limit:'Out of Range Limit',
      device_disabled:'Device Disabled',

      add:'Add',
      delete_rule:'Delete',
      push_content111:'Push Content',

      email_frequency:"Email Sending Frequency",
      receiving_mailbox:"Receiving Mailbox",
      save:'Save',
      cancel:'Cancel',

      table_rule_name:'Config Name',
      table_fence:'Fence',
      table_push_range:'Push Range',
      table_status:'Status',
      table_complete_schedule:'Complete Schedule',
      table_operate:'Operate',

      push:'Push',
      view:'View',
      edit:'Edit',
      record:'Record',

      push_part:'Part Push',
      push_all:'Push All',

      hour:'hour',
    },
    unInstallDeviceApp:{
      tab_name: 'App Uninstall',
      addOne: {
        btn_name_edit: 'Edit',
        btn_name_add: 'Add',
        modal_title_one: 'Add Uninstall App',
        modal_title_one1: 'Edit Uninstall App',
        modal_title_two: 'Uninstall app details',
        validate_config_name: 'Please enter a configuration name',
        validate_unInstall:'Please enter to uninstall the app',
        form_config_name: 'Configuration Name',
        form_message: 'Uninstall App',
        form_btn_cancel: 'cancel',
        form_btn_ok: 'Add',
        authentication_type_null: 'None',
        form_btn_ok1: 'Edit',
      },
      delete: {
        title: 'Delete Configuration'
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not pushed',
        view: 'View',
        config_name: 'Configuration Name',
        unInstallType:'Uninstall Method',
        unInstallPackageName:'Uninstall App',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',
        unInstallType_Name1:'Uninstall by app name',
        unInstallType_Name2:'Uninstall by package name',
        operation: 'Operate',
        validate_config_name_one: 'Configuration name should be less than 50 characters',
        validate_config_message_one: 'The message content does not exceed 300 characters'
      }
    },
    messagePush:{
      tab_name: 'Message Push',
      edit: 'Edit Message Push',
      addOne: {
        btn_name_edit: 'Edit',
        btn_name_add: 'Add',
        modal_title_one: 'Add pushMessage',
        modal_title_one1: 'Edit pushMessage',
        modal_title_two: 'PushMessage Details',
        validate_config_name: 'Please enter a configuration name',
        validate_message:'Please enter the push message',
        form_config_name: 'Configuration Name：',
        form_message: 'Push Message：',
        form_btn_cancel: 'Cancel',
        form_btn_ok: 'Add',
        authentication_type_null: 'None',
        form_btn_ok1: 'Edit',
      },
      delete: {
        title: 'Delete Configuration'
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not push',
        view: 'View',
        config_name: 'Configuration Name',
        push_message:'Message Content',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',

        operation: 'Operate',
        validate_config_name_one: 'Configuration name should be less than 50 characters',
        validate_config_message_one: 'The message content does not exceed 255 characters'
      }
    },
    bootLogo:{
      tab_name: 'Boot Logo',
      edit: 'Edit Boot Logo',
      addOne: {
        btn_name_edit: 'Edit',
        btn_name_add: 'Add',
        modal_title_one: 'Add bootLogo',
        modal_title_one1: 'Edit bootLogo',
        modal_title_two: 'PushMessage Details',
        validate_config_name: 'Please enter a configuration name',
        validate_message:'Please enter the Boot Logo',
        form_config_name: 'Configuration Name：',
        form_message: 'Boot Logo：',
        form_btn_cancel: 'Cancel',
        form_btn_ok: 'Add',
        authentication_type_null: 'None',
        form_btn_ok1: 'Edit',
        validate_boot_logo:'Please upload Boot Logo,format is img/bin',
        validate_boot_logo_type:'Please upload a file in img/bin format',
        bootLogoName:'File Name：',
      },
      delete: {
        title: 'Delete Configuration'
      },
      table: {
        handle_status_pushed: 'Pushed',
        handle_status_unpushed: 'Not push',
        view: 'View',
        config_name: 'Configuration Name',
        boot_logo:'Boot Logo',
        push_type: 'Push Range',
        handle_status: 'Push Status',
        finish_status: 'Status',

        operation: 'Operate',
        validate_config_name_one: 'Configuration name should be less than 50 characters',
        validate_config_message_one: 'The message content does not exceed 255 characters'
      }
    },
    bootAnimation:{
      save:'Save',
      tab_name:"Boot Animation",
      delete_rule:"Delete",
      btn_name_add:"Add",
      table_rule_name:"Config Name",
      table_rule_version:"Config Version",
      table_rule_push_range:"Push Range",
      table_rule_push_status:"Push Status",
      table_rule_finish_status:"Status",
      table_rule_create_time:"Create Time",
      table_rule_update_time:"Update Time",
      table_rule_operate:"Operate",
      table_rule_animation_type:"Animation Type",
      push_range_group:"Partial Push",
      push_range_tid_sn:"TID/SN Push",
      push_range_all:"Global Push",
      handle_status_unpushed:"Not push",
      handle_status_pushed:"Pushed",
      animation_type_default:"Default",
      animation_type_zip:"Upload ZIP",
      clone_tip:'You are about to clone this boot animation, do you want to continue??',

      error_upload_file_format_size:"The uploaded file needs to be a zip file, and the maximum size is 20M",
    },
  },
  // 霸屏应用
  occupyScreen: {
    add: {
      title: 'Create Occupy Screen',
      title1: 'Edit Occupy Screen',
      form_name: 'Config Name：',
      form_name_placeholder: 'Please input the name of configuration',
      form_push_range: 'Push Range',
      form_push_range_placeholder: 'Please select the push range',
      form_push_range_btn: 'Push Range',
      form_pwd: 'Unlock Pwd：',
      form_pwd_placeholder: 'Please input the unlock password(4 number)',
      form_app: 'Occupy App：',
      form_cancel: 'Cancel',
      form_create: 'Create',
      form_edit: 'Edit',
      form_app_version: 'Version:',
      modal_title: 'Select Push Range',
      modal_cancel: 'Cancel',
      modal_confirm: 'Confirm',
      modal1_title: 'Select Occupy Screen App',
      modal1_search: 'App Name',
      modal1_select: 'Select App',
      validate_name_empty: 'config name can not be empty',
      validate_orgName_empty: 'push range can not be empty',
      validate_lockPwd_empty: 'unlock password can not be empty',
      validate_lockPwd_er: 'please input 4 number',
      validate_app_empty: 'occupy app can not be empty',
      msg_add_success: 'create configuration successful',
      msg_edit_success: 'edit configuration successful',
    },
    table: {
      column_config_name: 'Config Name',
      column_occupy_app_name: 'Occupy Screen App',
      column_push_range: 'Push Range',
      column_status: 'Status',
      column_finish_status: 'Finish Status',
      column_operation: 'Operation',
      column_push: 'Push',
      show_detail: 'View',
      show_modal_title: 'Occupy Screen Detail',
    },
  },
  // 批量解绑设备
  batchUnbind: {
    btn_name: 'Bulk Unbind',
    header_tip: 'Bulk Unbind Devices',
  },
  // 设备生命周期
  deviceLifeCycle: {
    overview: 'Device Data Overview',
    overview_input: 'Input Number',
    overview_register: 'Register Number',
    search_form_sn: 'SN:',
    search_form_dvcType: 'Device Type:',
    search_form_inputTime: 'Input Date:',
    search_form_registerTime: 'Register Date:',
    search_form_btn_search: 'Search',
    search_form_btn_export: 'Export',
    table_column_sn: 'SN',
    table_column_sn_placeholder: 'Please input sn',
    table_column_dvcType: 'Device Type',
    table_column_dvcType_placeholder: 'Select device type',
    table_column_inputTime: 'Input Time',
    table_column_inputTime_begin: 'Begin Date',
    table_column_inputTime_end: 'End Date',
    table_column_registerTime: 'Register Time',
    table_column_orgName: 'Owner Organization(Merchant)',
  },
  // 用户角色权限
  authority: {
    form_header: 'Create Role',
    role_name_label: 'Role Name:',
    placeholder_1: 'please enter the role name',
    role_name_error1: 'role name must not be empty',
    role_name_error2: 'role name no more than 50 character',
    remark_label: 'Remark:',
    is_default: 'Is Default:',
    remark_placeholder: 'please enter the remark',
    remark_error1: 'remark no more than 100 character',
    form_btn_cancel: 'Cancel',
    form_btn_OK: 'Submit',
    tab_user: 'User',
    tab_role: 'Role',
    tab_menu: 'Menu',
    user_form_account: 'Account',
    user_form_org: 'Org/Merchant',
    user_form_role: 'Pointed Roles',
    user_form_option: 'Option',
    user_form_option_point: 'Allocate Role',
    allocate_modal_header: 'Allocate Role',
    allocate_form_role_name: 'Role Name',
    allocate_form_option: 'Option',
    allocate_delete: 'Delete',
    allocate_cancel: 'Cancel',
    allocate_ok: 'Submit',
    role_btn_create: 'Create',
    role_btn_delete: 'Delete',
    role_column_isDefault_true: 'True',
    role_column_isDefault_false: 'False',
    role_btn_edit: 'Edit',
    role_btn_allocate: 'Allocate Menu',
    role_column_name: 'Role Name',
    role_column_default: 'Default Role',
    role_column_remark: 'Remark',
    role_column_option: 'Option',
    role_column_create_time: 'Create Time',
    role_column_update_time: 'Update Time',
    role_column_create_user: 'Create Account',
    role_delete_title: 'Warning',
    role_delete_tip: 'deleting option will make the role lose the menu access, are you sure？',
    role_allocate_modal_title: 'Allocate Menu',
    role_allocate_modal_cancel: 'Cancel',
    role_allocate_modal_ok: 'Submit',
    role_allocate_modal_error1: 'Please select at least one menu',
    role_allocate_title: 'Warning',
    role_allocate_tip: 'Are you sure allocating the selected menus?',
    menu_tree_placeholder: 'Please enter the key for filtering',
    menu_tree_all: 'ALL',
    menu_tree_parent: 'Parent-Child',
    menu_detail_name: 'Menu Detail:',
    menu_form_parent_code: 'Parent Menu Code:',
    menu_form_parent_name: 'Parent Menu Name:',
    menu_form__code: 'Menu Code:',
    menu_form_btn_select: 'Select Parent Menu',
    menu_form_path: 'Menu Path:',
    menu_form_auth: 'Auth String:',
    menu_form_remark: 'Remark:',
    menu_form_i18: 'Internationalization:',
    menu_form_order: 'Order Number:',
    menu_form_edit: 'Edit Menu',
    menu_form_create: 'Create Menu',
    menu_form_delete: 'Delete Menu',
    menu_form_error1: 'Please select parent menu',
    menu_form_edit_title: 'Warning',
    menu_form_edit_tip: 'Are you sure to submit?',
    menu_form_delete_tip: 'Are you sure to delete the menu?',
    menu_selector_title: 'Select Menu',
    menu_create_parent_placeholder: 'Please select parent menu',
    menu_create_parent_placeholder1: 'Please select parent menu',
    menu_create_path_placeholder1: 'Please enter the menu path',
    menu_create_auth_placeholder1: 'Please enter the menu auth string',
    menu_create_note_placeholder1: 'Please enter remark',
    menu_create_i18_placeholder1: 'Please enter the internationalize string',
    menu_create_order_placeholder: 'Please enter the order number',
    menu_create_title: 'Create Menu',
    menu_form_path_val: 'menu path can not be empty',
    menu_form_path_val1: 'menu path should be less than 50 characters',
    menu_form_auth_val: 'menu auth can not be empty',
    menu_form_auth_val1: 'menu auth should be less than 50 characters',
    menu_form_i18_val: 'internationalize string can not be empty',
    menu_form_order_val: 'order number can not be empty',
    menu_form_i18_val1: 'internationalize string should be less than 100 characters',
    menu_form_order_val1: 'order number can only be number',
    menu_form_remark_val1: 'remark should be less than 100 characters',
  },


}


export default message



// WEBPACK FOOTER //
// ./src/assets/lang/EN/message_en_us.js